webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.37252ca.png";

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var store = {
  debug: true,
  state: {
    scrollTop: 0
  },
  setScrollAction: function setScrollAction(newValue) {
    if (this.debug) console.log('setScrollAction triggered with', newValue);
    this.state.scrollTop = newValue;
  },
  clearScrollAction: function clearScrollAction() {
    if (this.debug) console.log('clearScrollAction triggered');
    this.state.scrollTop = 0;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-qr.60e9107.png";

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      count: 0,
      fnScroll: function fnScroll() {},
      scrolled: false,
      dialogVisible: false,
      loginName: false,
      form: {
        name: '',
        pwd: ''
      }
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.fnThrottle(this.fnHandleScroll, 200), false);
    console.log('this.$route.path', this.$route.path);

    this.loginName = localStorage.getItem('loginXYDName');

    if (this.$route.path == '/setup' && !this.loginName) {
      this.$router.push('/');
    }
  },

  methods: {
    /**
     * @description [fnHandleScroll 内容区域滚动]
     * @author   shanshuizinong
     * @param    {Object}   e [事件对象]
     * @returns   {null}    [没有返回]
     */
    fnHandleScroll: function fnHandleScroll(e) {
      this.scrolled = window.scrollY > 50;
      __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].setScrollAction(window.scrollY);
    },

    /**
     * @description [fnThrottle 节流函数]
     * @author shanshuizinong
     * @param {Function} fn 延时调用函数
     * @param {Number} delay 延迟多长时间
     * @param {Number} atleast 至少多长时间触发一次
     * @return {Function} 延迟执行的方法
     */
    fnThrottle: function fnThrottle(fn, delay, atleast) {
      var timer = null;
      var previous = null;
      return function () {
        var now = +new Date();
        if (!previous) previous = now;
        if (atleast && now - previous > atleast) {
          fn();
          previous = now;
          clearTimeout(timer);
        } else {
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn();
            previous = null;
          }, delay);
        }
      };
    },

    // 登录
    login: function login() {
      var me = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('http://form.mixwechat.com/api/interface/info/hasdata/', {
        nx_formid: '60d594bb4c92a54a760b7e6c',
        name: this.form.name,
        pwd: this.form.pwd
      }).then(function (response) {
        response = response.data;
        if (response.code == 200 && response.data * 1 > 0) {
          me.dialogVisible = false;
          me.loginName = me.form.name;
          localStorage.setItem('loginXYDName', me.loginName);
          me.$message({
            message: '登录成功',
            type: 'success'
          });
        } else {
          me.$message.error('用户名或密码错误');
        }
      }).catch(function (error) {
        me.$message.error('服务器出错，请稍后再试');
      });
    },

    // 登出
    logout: function logout() {
      localStorage.setItem('loginXYDName', '');
      this.loginName = '';
      this.$message({
        message: '已登出',
        type: 'success'
      });
      if (this.$route.path == '/setup') {
        this.$router.push('/');
      }
    }
  },
  watch: {
    $route: function $route(nP, oP) {
      console.log('nP oP: ', nP, oP);
      if (nP.path == '/setup' && !this.loginName) {
        this.$router.push('/');
      }
    }
  }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      isShow: false,
      state: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state,
      isShowContaner: false,
      isShowPartenr: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      window.scrollTo(0, 0);
      _this.isShow = true;
    }, 100);
  },

  watch: {
    'state.scrollTop': function stateScrollTop(val, oldVal) {
      console.log('home scrollTop:', val, oldVal);
      this.isShow = val < 600;

      this.isShowContaner = val > 1500 && val < 2500;

      this.isShowPartenr = val > 2700 && val < 3600;
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAA1VBMVEUAAAD2/f/x9//y+P/x9//x9v/w9//x9//x9//w+P/y9//y+P/y+f/////x9//w9//w9//x9v/x9v/x9//w9//w9v/w9//x9v/w9v/w9v/x9//w9//x9v/w9//x+P/x9v/y+f/x+P/y9v/1+v/z+f/39//////////w9v4AjPtZs/yg0/2Cx/203f5ftvwvovvd7v4Ok/samPvE4/4Gj/vo8/7k8v7t9v6RzP2w2v0knPup1/11wP1HrPyJyf3X6/6b0f06pvzK5v5uvfxRsPy43v6/4P4dXaDFAAAAKHRSTlMAG7iG+ezgxaVpYUMoA/r18+vl1tLNvrOtrKCckHluWE9JOzIqIA0KT+j2UQAABE5JREFUeNrM01magjAUROEbAgkQQHFCRQWcqP2vsB/6lVbIcL/+t1B1yJow2eUU6Z1K4jhROx2dLpkRxKrI0v0ak9b7NCuIwytPN/hik+YvCkpct5hpew020zs/YJFD/ib/nucVFludn+TX4whLxwf5c4/gILr7ijWCo8hH0KOM4SyWIznqFbxQPbkQDbxpBFkbanhUD2SnlPBMllazaHinLeYxCQJIDC3UVQii6miRG4K50QISAcn5ubQIqp0bT4vA2n+wyy/p9FPmx3Zg8bViU4FFZegjkYBJIj6Gq8FGlw7BcKUzgNVAfxA1WNWCpjVg1tCkHux6mjAqsFMjQzG25RQ/xNdJj4JAEIbhkuCCmmjcokYvbqmCzIBAcHAZx5j5/39pCAwp4sXu4tDviXB68gXoYKOB7D68ZqGRLHhpg0oFqadYGqBSG8kgkU8a+ZFgki0qlMakVZyiQluoNsf3JSFpFib4vjlU2qFCHmnnoUI74Jao0JO0e6JCS3YcBqiQS9q5qNDgAGVdNAnBLpTNzEJmpaOBZiHYgKK1acgaisamIWPI26NpCO6Ld8Y8pHhvOuYhnRwyMg8ZQVYfJZCjd7lcvDNVCvNbRwkE+wDgyCABZqVU6QezAhnE4UdEB8Ln2YNvnE98MjJE4yGZyiDxnSfhQe6xDDIFgKEMQi5PwoO4JIMMARoohFBUTsKDRCSEYAN6YsitnIQHuYkhPXDEEEox64MHya7FEAdWcohfTMKD+HLIChZyCHnFDOUgHskhC7CEEN7h8X9xOteAWNCuAaHvYpJikC+qAWnDpA7kmOST5IMkYR3IBFoCCHfFrF8Ps65UB9KCphjCH3o+7cSQJtgSCPfJ/4G1IPYfs2avmzAMRWHDgEIm1KGqKibawSlxYqdOSkUgUmTy/o9EbCF5QEgH34H7TR4/ycd/95ogYtXvjLwxzuOLSRchTE0j76gJU7PiIbKiLN++9Ezh2A3D3hKWL2VDC5RxMyNtaEseIkvKoecqz3/Y08Lwh3LobSWLsG7FmofImnBVNEPrCVeBv86jG8JVcSFZhHUhxIaDyMY/sDiI+AdWxkEkwx7hgzt0qSLdwQ3AosHKEqoorDs+EKnLmfqByNHZolBYWUK8ASIkFFaoEdnrRTLhyV8vkoPlzYkmMgHlTbDge6lMqoWpFFDwxUvg7f5kEzRO+xYvgaPHjT7Xz1nUZw0eNLFNAjL2DWrR9KMEeb9rHCGoymDBwMmBVhoQFyAYQCsNay7icYnBwPkE2q1AXFKDEfkGGtBgXGIwEvhAWvJAXG4W1gcjiS/qr40YFyAY+L+NnUxHa5nOjutHFj5fe67N3AEJAAAAgKD/r1sR+CNjYicn/2KCOCcRdKJJJiN1wlonNWbiaydHdwJ9hyw4iMNhLQ70YegThMEcHueAQYdQOqjUYbYQPHYoNoTTHa4PDQygpQM0uYC2H9AIRVrDSLOcax8UjwHq9zCqGIYAAAAASUVORK5CYII="

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAAt1BMVEUAAAD2/f/x9//x9v/x9//y+P/x+P/z+f/w9//w9//x9//w9v/x9//x9//y9//y+P/////x9v/x9//w9//w9v/w9//x9v/x9v/w9//x9v/y+f/x+P/y9v/1+v/39//////////w9v4AjPtKrfyk1P0RlPvs9f5RsPyt2f0soPvh8P4Fj/t4wf1Mrvy53v5rvPwHj/vp9P6Szf2Dx/0im/samPsNkvuf0/2c0f1AqPwwovva7P7X6/7cKGW8AAAAIXRSTlMAG/rsuIZrKPTgxaylnmFDA+XW0s2+s5B5WE9JOzIgDQqGu5qjAAAEHUlEQVR42szTiXWDMBRE0a8VJBDCG7bBC3NSgvvvLSmAAwgkxbeFmUebMa+vlbQnIzgX5mRlddWeUVaFrs8lJpXnWheUw6upD1hwqJsXJcVuR6x0vCWb6d1cEOTSvCm+wpUIVrrYf3lW2Kh6UjwPiR3kI9YoEjvJGAONimM3rkbaqTeIwvS0B+sQTcdos0EgIjHQNq1CZKrdNItFdJZRMC+QgPAU6M6RBL9TEI1kNAVQSEitz8UhKbc2HofE3BfsErCORgZ6RbfIYrFiz5EF9zSLCWQi2Gy4FtnYNnsw4ekMyGr4/4Ms3KRDZh1N6pFdTxNGg+zMGLGYz8+fD2aElVP80mKvOwkDQRiGBySCYjSeoj885Btlt7RAKYdy0Pu/LgmEhYTqfoP6/G6TN81OOm0dx+nqShfHqTcPQhogsCG8xsF3Ngh8CO/J9kB+GcI/kmdQ+BDes+xrg/A/IW3Z0wSJD+E1/2hdXujKAnHEKv3aAuEDlVy64qhbqrVeZesScc5nCYySoXeIu5Ste6ZDNUusHapMyX3YQ7iOUGLo4EpqsvGIqHfVUMJ3rM0Q9SgbN4hy/cqSIun55aTTmSx9LykqO94com5k7QUwlHxiK537UveUfp7u5oXpCF7CzNAlfbfNyDM9kOUhxYcOem4uQJeEjmJcaqVyXITjTXfgYh1yDbYkdAym+q3pIJSwHbi2vWfczGFtlOkPstHuclbzmN8QLteI3MHoNBwRnnvTiIOzwR2SO9jkSshhcyciLZiMlDKCSUukBpNBppRsAJOaXMGimCppWsDiyjg0Y6WNYXEqDzBIO0rrpDB4sO3vuRrkMGhLA7x0qAbDFLyGnIM3U5MZeOdyC55XEw/erZyB5ko1KR1oZ3ICWqJGCWgnUgetp0Y90OpfzNrLjoJAEIXhg0NoZiAaHSe6GDXVXtgQFgYT9f0fzNAmbrsPMVZ9T/BHgc0pJqTxpIYIYf6auyfdJdkX87D2ntRLsm/m9b140kWS/TIftKMnHSXZD3IbITkqGyEVVjZCVihGhEjw1pACMxshM2Q2QjKgtBBSAlhaCFkCqC2E1AAKCyEFAGchxAHAXD9kjkGtH1JjMNUPmWKw1Q/ZIlhohyzwtNYOWaePAkHPhvSSJiNmkkHLhrSS5I8ZjoJzsw8k2Ec0Z+KdeU1pisrdR27xqHERThS5yAD9KRU9yXcHWidxG/JI4XTzI9xOEpGzZxtXP8pVIv7ZQ5bWj9IyP0jgJhohE0cfO3WPZu7YBAAAhIFg5STW2X89RxAE4ZzB8i/pw2V515LzLyaIcxJBJ5pkMlInrHVSYya+dnJ0J9B3yIKDOBzW4kAfhj5BGMzhcQ4YdAilg0odZgvBY4diQzjd4frQgAE06QCNXECzH9AQijQNI43lfM0HDR6RWWWERoYMAAAAAElFTkSuQmCC"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAAjVBMVEUAAAD2/f/x9//x9v/y+P/w9//w9//x9//x9//x9//x9//w9v/x9//x9//w+P/y9//y+P/y+f/x9v/w9v/w9//x9v/w9//x+P/x9v/y+f/x+P/y9v/1+v/z+f/39//////////w9v4AjPt3wfyVzv1+xP0Vlvvs9f7Z7P633f6JyP1dtfxQsPwwofsuoftWy9g2AAAAIXRSTlMAG/rshvTg1MW5taylnmlhQyjlzb6QeW5YT0k7MiogDQq3IXjOAAAC1ElEQVR42szWCW7bMBSE4SGpfZe3eLcnbgIkRe9/vaIV4MSBoY0Sye8EP8A3ADGaqIp1GkdhoKRUQRjF6bqoBIyqi2zp8yl/mRU1TDiX2YIdFll5xqzEJmRP4UZgJpdyxUFW5QXTO+U+B/PzE6Z1TDlSesR0Dgk1JAdMo46pKa6h7+pJapPeFZp2AScR7KBDJJxMIjDaXnFCao+RPE7Mwxgi4uQigcEqxRmoCgNtJWchtxjkhbN50TlTWyebc1a5Ix1k7sC7NDydOzV9sVsa0bniStIIWaGVUDRECbSJaEykNRhD09nTqL39A+k4k4SGJXhqR+N2eOIa0LjgOmIxn++vg71/Dl9OLdnq43WUD7aSNX6K2e5tXMgb28X44cAOt3EhN3Y44FFiKyTBgyNthfCI71J7ISm+ObF3yO/bgz/aITzhS94/hI9+6YfkuLv4NkP8yz2kpM0QlveQld2QFdAQpM1jJQUaG5KW5tvYoBHaDgnx35m2Q3huNmM/pNlNZj8kwz8L+yELAKhpP4Q1gIIOKABkdEAGYEkHLAH4dIAPCDpBoGIfc6+GFQo3Qgqs3QhZI3UjJEXsRkiMyI2QCKEbISEC9qH5Z+0WQLEPzV98NwXpRoj828y940AIw1AU9RRUCE0zLUIuGCgQ+18eogHqKCjHK7BEEvx59zmJMJ+GOazM9WUeNOaJZ356TBnAFEZMqcgUz0w74TRYTMvJNOHMWIIZ1DijK2aYx4w3mYHvCyPwf9kI/FM5kW3NdStZCsSvaiL7kpnLXrAmiW/VROY8Yy5ZHE1dy0S6Ka4YWn6aIe4YWx7WMR7Rt7u+vbmSZ0QKjmyDEbI40h5G7OTIvxhBnCMRdESTjIzUEdY6UmNHfM3I0R2BvoMsOBCHg7U4oI+DPjkwmIPHOcCgg1A6UCmE2TrgsYNiQ3C6g+tDBgaQpQNkcgHZfkBGKJI1jGSW85Z90AHTv1RQ4OiPfAAAAABJRU5ErkJggg=="

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAMAAAALZFNgAAAAqFBMVEUAAAD2/f/x9//x9//y+P/z+f/v9//x9v/w9//x9//x9//x9//w+P/y9//y+P/////////x9v/x9v/x9//w9//w9v/w9//x9v/w9v/w9v/x9v/w9//x+P/x9v/y+f/x+P/y9v/1+v/39//w9v4AjPuz3P5Zs/yGx/1RsPx3wf1/xP0knPsdmPu+4P7a7P6g0/0uofvR6f7Q6P5Aqfw/qPwRlPsPk/sDjfsrKfIfAAAAI3RSTlMAG/q4hij27ODFpZ5pYUMLA+vl1tLNvrOtrJB5blhPSTsyIBJtoLQAAALUSURBVHjazNbXTuNAGIbhb9wdN9IbpH2BQLKwbL//O9uMsigoG3Abj+c5sn754JU9v2xUJtJ4NrXDQeBblh8MQns6i1MBrdy4M/R4lTfsxC502CSdHnP0OskGjRLzPgvqzwUakiUjljJKMqjnRh5L8yIXaq0nrGiyhjormzXYK6jh2qzJdlFf5liszXIy1LQIqESwQB1iTGXGApUtu1Sou0Q1Nw4Vc25QgQipXChQWuqzAX6Kku4sNsK6Qym3bMwtSnDYIKf4ukRsVFR0eSI2LDLgvZw4+s9p9RN7Ry1ytzi1qIWV4lPCpya++HRxQ2oT3mhbmOqrs6RWS3xAdKlVV+C6MTUb46oFtVvgiiygdkGmYWOqbo5rsQWWi0s2W2HjwootWZnxQP57JGu2Zo33JmzNBO+4LODb09FXKueW/V3eb48OVC46d2QeczUX4mV4kzBf2ZAf8u5iLzLBm1EDIQd5955FjPCPYA5v/3T0c3v060l65tnzaVAjhAInc+a431544NmjHDzWCpnjpN92SP/UsWHbIdxAStoPSSB12g/pQOopDtl9kf7I8W95dfjOPL3Td0ZxyMP2wn2x701sQkgsj4gJIfKQDE0IGQLwTAjxAEETQiiQmhGSIq4e8rKTXuXgdSe9VA+JMasesrsc76qHzDA1I2QK24wQG6EZISEGZoQMEJgREsA3I8SHZUaI9beZO6EBGIiBGMiftVFYGgaV+l2y9joXwtwa5mFlXl/mg8Z84pmfHnMMYA5GzFGROTwz44QzYDEjJzOEM2sJZlHjrK6YZR6z3mQWvs4KnAkFmJjECY6YKI0JF524lQmgnUiegRQcbIMBWRy0h4GdHPyLAeIcRNCBJhmM1AFrHdSYga8dHN0B9B1lwZE4HK3FEX0Y9QmSwRw9zhEGHYXSkUodzRYSjx0VG5LTHV0fKjCAKh2gkguo9gMqQpGqYaSynKs+KAKQxRDgstAOAAAAAElFTkSuQmCC"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/school-nj.2f074ff.png";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/school-hn.e2c059a.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/school-sj.53e6a7f.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/store-custom3.646f2e4.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/store-custom1.73d79c5.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-custom3.b1d893c.png";

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      isShow: false,
      state: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state,
      isShowContaner: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      window.scrollTo(0, 0);
      _this.isShow = true;
    }, 100);
  },

  watch: {
    "state.scrollTop": function stateScrollTop(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;

      this.isShowContaner = val > 1000 && val < 2000;
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/store-banner-circle.a671f4c.png";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_swiper_min_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_swiper_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      isShow: false,
      state: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state,
      // isShowContaner: false,

      swiperOption: {
        observer: true,
        // direction: "vertical",
        slidesPerView: "auto",
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        mousewheel: true,
        loop: true,
        on: {
          // 这里注册事件
        }
      }
    };
  },

  components: {
    Swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["Swiper"],
    SwiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["SwiperSlide"]
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      window.scrollTo(0, 0);
      _this.isShow = true;
    }, 100);
  },

  watch: {
    "state.scrollTop": function stateScrollTop(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;

      // this.isShowContaner = val > 1000 && val < 2000;
    },
    "$refs.mySwiper.swiperInstance.activeIndex": function $refsMySwiperSwiperInstanceActiveIndex(val, oldVal) {
      console.log("$refs.mySwiper.swiperInstance.activeIndex:", val, oldVal);
    }
  }
});

/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      isShow: false,
      state: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      window.scrollTo(0, 0);
      _this.isShow = true;
    }, 100);
  },

  watch: {
    "state.scrollTop": function stateScrollTop(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_docxtemplater__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_docxtemplater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_docxtemplater__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pizzip__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pizzip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pizzip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip_utils__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jszip_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_template1_docx__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_template1_docx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_template1_docx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      act: 1,
      state: __WEBPACK_IMPORTED_MODULE_0__store_js__["a" /* default */].state,
      isShow: false,
      curStep: 1,
      formSelections: { // 选项设置
        setupMachine: [// 配置机型选项
        '机型1', '机型2'],
        setupCPU: [// CPU选项
        'AMD 7442|核数64；主频2.3GHz;睿频3.0GHz;缓存256M', 'intel 6230R|核数24；主频3.0GHz;睿频4.0GHz;缓存128M'],
        setupMemery: [// 内存选项
        '16G DDR4', '32G DDR4'],
        setupNetwork: [// 网络选项
        'Mellanox 100Gb infiniband HCA卡', '16Gb FC HBA卡'],
        setupHardDisk: [// 硬盘选项
        '300Gb HDD', '480Gb SSD'],
        setupGPU: [//GPU选项
          // 'GPU1','GPU2','GPU3'
        ],
        setupFri: '', //存储节点U3100
        setupSed: '', //存储节点U3200
        setupThr: '', //存储节点U5000
        setupFloat: 0, //理论浮点定制
        setupCache: [//控制器缓存
          // '64G DDR4 ','128G DDR4','256G DDR4'
        ],
        setupDual: [//双控制器缓存
          // '64G DDR4 ','128G DDR4','256G DDR4'
        ],
        setupDisk: [//控制器硬盘
          // '1.92T SSD','10T HDD','14T HDD'
        ],
        setupExpansion: [//扩展柜类型
          // '2U12盘位','4U24盘位','4U60盘位'
        ],
        setupExcabinet: [//扩展柜硬盘
          // '1.92T SSD','10T HDD','14T HDD'
        ],
        setupSwitch: [// 万兆网络交换机型号
          // 'SX6012','SX6024'
        ],
        setupSwitchThousand: [], // 千兆网络交换机型号
        setupMellanox: [//Mellanox网络

        ],
        setupIntel: [//intel OPA网络

        ]
      },
      form: {
        // 管理节点
        managementNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [// 网络列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupHardDisks: [// 硬盘列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupGPUs: [//GPU 可多选
          {
            type: '', //类型
            number: 0 //数量
          }]
        },
        // 登录节点
        loginNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [// 网络列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupHardDisks: [// 硬盘列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupGPUs: [//GPU 可多选
          {
            type: '', //类型
            number: 0 //数量
          }]
        },
        // 计算节点
        computeNode: {
          setupMachine: '', // 配置机型
          numberMachine: 0, // 配置数量
          setupCPU: '', // CPU
          numberCPU: 0, // CPU数量
          setupMemery: '', // 内存
          numberMemery: 0, // 内存数量
          setupNetworks: [// 网络列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupHardDisks: [// 硬盘列表 可多选
          {
            type: '', // 类型
            number: 0 // 数量
          }],
          setupGPUs: [//GPU 可多选
          {
            type: '', //类型
            number: 0 //数量
          }]

        },
        //存储节点
        storageNode: {
          setupType: 'U3100', //存储节点radio
          numberStorage: 0, //存储节点数量
          setupCache: '', //控制器缓存
          setupDual: '', //双控制缓存
          setupDisks: [//控制器硬盘 可多选
          {
            type: '', //类型
            number: 0 //数量
          }],
          setupExpansion: '', //扩展柜类型
          numberExpansion: '', //扩展柜数量
          setupExcabinets: [//扩展柜硬盘
          {
            type: '', //类型
            number: 0 //数量
          }]
        },
        //网络节点
        networkNode: {
          // setupNetType:'万兆网络',//网络节点radio
          setupSwitchsSelect: false,
          setupSwitchsThousandSelect: false,
          setupSwitchsMellanoxsSelect: false,
          setupSwitchsIntelsSelect: false,
          setupSwitchs: [// 万兆网络交换机型号 可多选
          {
            type: '', //类型
            number: 0 //数量
          }],
          setupSwitchsThousand: [// 千兆网络交换机型号 可多选
          {
            type: '', //类型
            number: 0 //数量
          }],
          setupSwitchsMellanoxs: [//Mellanox网络 可多选
          {
            type: '', //类型
            number: 0 //数量
          }],
          setupSwitchsIntels: [//intel OPA网络 可多选
          {
            type: '', //类型
            number: 0 //数量
          }]
        }
      }
    };
  },

  watch: {
    'state.scrollTop': function stateScrollTop(val, oldVal) {
      console.log('home scrollTop:', val, oldVal);
    }
  },
  created: function created() {
    var me = this;
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('http://form.mixwechat.com/api/interface/info/data/', {
      _id: '60d598034c92a54a760b7e70'
    }).then(function (response) {
      // debugger
      response = response.data;
      if (response.code == 200 && response.data.data.length > 0) {
        me.formSelections.setupMachine = response.data.data.find(function (d) {
          return d.setupname == '配置机型';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupCPU = response.data.data.find(function (d) {
          return d.setupname == 'CPU';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupMemery = response.data.data.find(function (d) {
          return d.setupname == '内存';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupNetwork = response.data.data.find(function (d) {
          return d.setupname == '网络';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupHardDisk = response.data.data.find(function (d) {
          return d.setupname == '硬盘';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupCache = response.data.data.find(function (d) {
          return d.setupname == '控制器缓存';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupDual = response.data.data.find(function (d) {
          return d.setupname == '双控制器缓存';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupDisk = response.data.data.find(function (d) {
          return d.setupname == '控制器硬盘';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupExpansion = response.data.data.find(function (d) {
          return d.setupname == '扩展柜类型';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupExcabinet = response.data.data.find(function (d) {
          return d.setupname == '扩展柜硬盘';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupSwitch = response.data.data.find(function (d) {
          return d.setupname == '万兆网络交换机型号';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupSwitchThousand = response.data.data.find(function (d) {
          return d.setupname == '千兆网络交换机型号';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupGPU = response.data.data.find(function (d) {
          return d.setupname == 'GPU';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupFloat = response.data.data.find(function (d) {
          return d.setupname == '理论浮点定制变量';
        })['setup'];
        me.formSelections.setupMellanox = response.data.data.find(function (d) {
          return d.setupname == 'Mellanox网络交换机型号';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupIntel = response.data.data.find(function (d) {
          return d.setupname == 'intel OPA网络交换机型号';
        })['setup'].split(/[\,，]/g);
        me.formSelections.setupFri = response.data.data.find(function (d) {
          return d.setupname == 'U3100';
        })['setup'];
        me.formSelections.setupSed = response.data.data.find(function (d) {
          return d.setupname == 'U3200';
        })['setup'];
        me.formSelections.setupThr = response.data.data.find(function (d) {
          return d.setupname == 'U5000';
        })['setup'];
      } else {
        me.$message.error('用户名或密码错误');
      }
    }).catch(function (error) {
      me.$message.error('服务器出错，请稍后再试');
    });
  },

  methods: {
    networkPlus: function networkPlus(node) {
      // 增加网络
      node.setupNetworks.push({
        type: '', // 网络类型
        number: 0 // 网络数量
      });
    },
    networkMinus: function networkMinus(node, index) {
      // 减少网络
      node.setupNetworks.splice(index, 1);
    },
    hardDiskPlus: function hardDiskPlus(node) {
      // 增加硬盘
      node.setupHardDisks.push({
        type: '', // 硬盘类型
        number: 0 // 硬盘数量
      });
    },
    hardDiskMinus: function hardDiskMinus(node, index) {
      // 减少硬盘
      node.setupHardDisks.splice(index, 1);
    },
    diskPlus: function diskPlus(node) {
      //控制器硬盘增加
      node.setupDisks.push({
        type: '', //控制器个数
        number: 0 //控制器数量
      });
    },
    diskMinus: function diskMinus(node, index) {
      //控制器硬盘减少
      node.setupDisks.splice(index, 1);
    },
    gpuPlus: function gpuPlus(node) {
      //GPU增加
      node.setupGPUs.push({
        type: '', //GPU个数
        number: 0 //GPU数量
      });
    },
    gpuMinus: function gpuMinus(node, index) {
      //减少GPU
      node.setupGPUs.splice(index, 1);
    },
    excabinetPlus: function excabinetPlus(node) {
      //扩展柜硬盘增加
      node.setupExcabinets.push({
        type: '', //扩展柜硬盘个数
        number: 0 //扩展柜硬盘数量
      });
    },
    excabinetMinus: function excabinetMinus(node, index) {
      //控制器硬盘减少
      node.setupExcabinets.splice(index, 1);
    },
    switchPlus: function switchPlus(node) {
      node.setupSwitchs.push({ //扩展柜硬盘增加
        type: '', //扩展柜硬盘个数
        number: 0 //扩展柜硬盘数量
      });
    },
    switchMinus: function switchMinus(node, index) {
      //扩展柜硬盘减少
      node.setupSwitchs.splice(index, 1);
    },
    mellanoxPlus: function mellanoxPlus(node) {
      node.setupSwitchsMellanoxs.push({ //Mellanox网络增加
        type: '', //Mellanox网络个数
        number: 0 //Mellanox网络数量
      });
    },
    mellanoxMinus: function mellanoxMinus(node, index) {
      //Mellanox网络减少
      node.setupSwitchsMellanoxs.splice(index, 1);
    },
    intelPlus: function intelPlus(node) {
      node.setupSwitchsIntels.push({ //intel OPA网络增加
        type: '', //intel OPA网络个数
        number: 0 //intel OPA网络数量
      });
    },
    intelMinus: function intelMinus(node, index) {
      //intel OPA网络减少
      node.setupSwitchsIntels.splice(index, 1);
    },
    switchThousandPlus: function switchThousandPlus(node) {
      node.setupSwitchsThousand.push({ //扩展柜硬盘增加
        type: '', //扩展柜硬盘个数
        number: 0 //扩展柜硬盘数量
      });
    },
    switchThousandMinus: function switchThousandMinus(node, index) {
      //扩展柜硬盘减少
      node.setupSwitchsThousand.splice(index, 1);
    },
    getGFlops: function getGFlops() {
      if (!this.form.computeNode.setupCPU) {
        return 0;
      }
      return (/核数(\d+)/g.exec(this.form.computeNode.setupCPU)[1] * this.form.computeNode.numberCPU * this.form.computeNode.numberMachine * this.formSelections.setupFloat * /主频([\d.]+)/g.exec(this.form.computeNode.setupCPU)[1]
      );
    },
    downloadWord: function downloadWord() {
      // 下载word
      var toObj = {
        "managementType": this.form.managementNode.setupMachine,
        "managementNum": this.form.managementNode.numberMachine,
        "managementCPU": this.form.managementNode.numberCPU > 0 ? this.form.managementNode.numberCPU + ' * ' + this.form.managementNode.setupCPU : '-',
        "managementMemery": this.form.managementNode.numberMemery > 0 ? this.form.managementNode.numberMemery + ' * ' + this.form.managementNode.setupMemery : '-',
        "managementNetworks": this.buildText(this.form.managementNode.setupNetworks),
        "managementHardDisks": this.buildText(this.form.managementNode.setupHardDisks),
        "managementGPU": this.buildText(this.form.managementNode.setupGPUs, 'GPU：'),
        "loginType": this.form.loginNode.setupMachine,
        "loginNum": this.form.loginNode.numberMachine,
        "loginCPU": this.form.loginNode.numberCPU > 0 ? this.form.loginNode.numberCPU + ' * ' + this.form.loginNode.setupCPU : '-',
        "loginMemery": this.form.loginNode.numberMemery > 0 ? this.form.loginNode.numberMemery + ' * ' + this.form.loginNode.setupMemery : '-',
        "loginNetworks": this.buildText(this.form.loginNode.setupNetworks),
        "loginHardDisks": this.buildText(this.form.loginNode.setupHardDisks),
        "loginGPU": this.buildText(this.form.loginNode.setupGPUs, 'GPU：'),
        "computeType": this.form.computeNode.setupMachine,
        "computeNum": this.form.computeNode.numberMachine,
        "GFlops": this.getGFlops(),
        "computeCPU": this.form.computeNode.numberCPU > 0 ? this.form.computeNode.numberCPU + ' * ' + this.form.computeNode.setupCPU : '-',
        "computeMemery": this.form.computeNode.numberMemery > 0 ? this.form.computeNode.numberMemery + ' * ' + this.form.computeNode.setupMemery : '-',
        "computeNetworks": this.buildText(this.form.computeNode.setupNetworks),
        "computeHardDisks": this.buildText(this.form.computeNode.setupHardDisks),
        "computeGPU": this.buildText(this.form.computeNode.setupGPUs, 'GPU：'),
        "storeType": this.form.storageNode.setupType,
        "storeCacheSum": this.buildStoreCacheSum(this.form.storageNode),
        "storeNum": this.form.storageNode.numberStorage,
        "storeDesc": this.form.storageNode.setupType == 'U3100' ? this.formSelections.setupFri : this.form.storageNode.setupType == 'U3200' ? this.formSelections.setupSed : this.formSelections.setupThr,
        "storeCache": this.form.storageNode.setupType == 'U3100' ? "控制器缓存：" + this.form.storageNode.setupCache : "双控制器缓存：" + this.form.storageNode.setupDual,
        "storeDisks": this.form.storageNode.setupType == 'U3100' ? "控制器硬盘：" + this.buildText(this.form.storageNode.setupDisks) : '',
        "storeExpansion": this.form.storageNode.numberExpansion > 0 ? this.form.storageNode.numberExpansion + ' * ' + this.form.storageNode.setupExpansion : '-',
        "storeExpansions": this.buildText(this.form.storageNode.setupExcabinets),
        // "networkType": this.form.networkNode.setupNetType,
        // "networkSwitchs": this.buildText(this.form.networkNode.setupNetType == '万兆网络' ? this.form.networkNode.setupSwitchs : (this.form.networkNode.setupNetType == 'Mellanox Infiniband网络' ? this.form.networkNode.setupSwitchsMellanoxs : this.form.networkNode.setupSwitchsIntels))
        "networkType1": '',
        "networkType1Unit": '',
        "networkType1Num": '',
        "networkSwitchs1": '',
        "networkType2": '',
        "networkType2Unit": '',
        "networkType2Num": '',
        "networkSwitchs2": '',
        "networkType3": '',
        "networkType3Unit": '',
        "networkType3Num": '',
        "networkSwitchs3": '',
        "networkType4": '',
        "networkType4Unit": '',
        "networkType4Num": '',
        "networkSwitchs4": '',
        "networkType": '' // (this.form.networkNode.setupSwitchsSelect ? '万兆网络、' : '') + (this.form.networkNode.setupSwitchsMellanoxsSelect ? 'Mellanox Infiniband网络、' : '') + (this.form.networkNode.setupSwitchsIntelsSelect ? 'intel OPA网络、' : '') + (this.form.networkNode.setupSwitchsThousandSelect ? '千兆网络、' : '').replace(/、/g, '')


        // 生成选中网络列表
      };var saveNetworks = [];
      if (this.form.networkNode.setupSwitchsSelect) {
        saveNetworks.push({
          type: '万兆网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchs.map(function (s) {
            return s.number;
          }).reduce(function (t, s) {
            return t + s;
          }),
          switchs: this.buildText(this.form.networkNode.setupSwitchs, '交换机型号：')
        });
      }
      if (this.form.networkNode.setupSwitchsMellanoxsSelect) {
        saveNetworks.push({
          type: 'Mellanox Infiniband网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsMellanoxs.map(function (s) {
            return s.number;
          }).reduce(function (t, s) {
            return t + s;
          }),
          switchs: this.buildText(this.form.networkNode.setupSwitchsMellanoxs, '交换机型号：')
        });
      }
      if (this.form.networkNode.setupSwitchsIntelsSelect) {
        saveNetworks.push({
          type: 'intel OPA网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsIntels.map(function (s) {
            return s.number;
          }).reduce(function (t, s) {
            return t + s;
          }),
          switchs: this.buildText(this.form.networkNode.setupSwitchsIntels, '交换机型号：')
        });
      }
      if (this.form.networkNode.setupSwitchsThousandSelect) {
        saveNetworks.push({
          type: '千兆网络',
          unit: '台',
          num: this.form.networkNode.setupSwitchsThousand.map(function (s) {
            return s.number;
          }).reduce(function (t, s) {
            return t + s;
          }),
          switchs: this.buildText(this.form.networkNode.setupSwitchsThousand, '交换机型号：')
        });
      }

      var saveNames = [];
      saveNetworks.forEach(function (n, idx) {
        toObj['networkType' + (idx + 1)] = n.type;
        toObj['networkType' + (idx + 1) + 'Unit'] = n.unit;
        toObj['networkType' + (idx + 1) + 'Num'] = n.num;
        toObj['networkSwitchs' + (idx + 1)] = n.switchs;
        saveNames.push(n.type);
      });

      toObj['networkType'] = saveNames.join('、');

      console.log('toObj: ', toObj);
      this.exportDocx(__WEBPACK_IMPORTED_MODULE_6__assets_template1_docx___default.a, toObj, '项目方案.docx');
    },
    buildText: function buildText(arr, prefix) {
      var toStr = [];
      arr.filter(function (a) {
        return a.number > 0;
      }).forEach(function (a) {
        toStr.push(a.number + ' * ' + a.type);
      });
      if (!prefix) {
        return toStr.length > 0 ? toStr.join(' + ') : '-';
      }
      return toStr.length > 0 ? prefix + toStr.join(' + ') : '';
    },

    // 存储容量计算
    buildStoreCacheSum: function buildStoreCacheSum(storeNode) {
      var toArr = [];
      if (storeNode.setupType == 'U3100') {
        storeNode.setupDisks.filter(function (a) {
          return a.number > 0;
        }).forEach(function (a) {
          toArr.push(a.type.replace(/[^\d.]/g, '') + '*' + a.number);
        });
      }

      storeNode.setupExcabinets.filter(function (a) {
        return a.number > 0;
      }).forEach(function (a) {
        toArr.push(a.type.replace(/[^\d.]/g, '') + '*' + a.number);
      });

      return toArr.join('+');
    },
    exportDocx: function exportDocx(tempDocxPath, data, fileName) {
      // 读取并获得模板文件的二进制内容
      __WEBPACK_IMPORTED_MODULE_4_jszip_utils___default.a.getBinaryContent(tempDocxPath, function (error, content) {
        if (error) {
          throw error;
        }
        var zip = new __WEBPACK_IMPORTED_MODULE_3_pizzip___default.a(content);
        var doc = new __WEBPACK_IMPORTED_MODULE_2_docxtemplater___default.a().loadZip(zip);
        doc.setData(data);
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render();
        } catch (error) {
          var e = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            properties: error.properties
          };
          console.log({
            error: e
          });
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
          throw error;
        }
        var out = doc.getZip().generate({
          type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }); // Output the document using Data-URI
        Object(__WEBPACK_IMPORTED_MODULE_5_file_saver__["saveAs"])(out, fileName);
      });
    }
  }
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2386d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(144)
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e2386d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2386d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$route.path === '/setup' ? '' : 'white',attrs:{"id":"app"}},[_c('header',{class:_vm.scrolled ? 'over' : ''},[_c('nav',{staticClass:"nav"},[_c('img',{attrs:{"src":__webpack_require__(14)}}),_vm._v(" "),(_vm.$route.path === '/setup')?_c('span',{staticClass:"setup-title"},[_vm._v("信易达超算配置系统")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"ul"},[_c('li',[_c('a',{class:_vm.$route.path === '/' ? 'active' : '',attrs:{"href":"#/"}},[_vm._v("首页")])]),_vm._v(" "),_c('li',[_c('a',{class:_vm.$route.path === '/store' ? 'active' : '',attrs:{"href":"#/store"}},[_vm._v("高性能存储")])]),_vm._v(" "),_c('li',[_c('a',{class:_vm.$route.path === '/software' ? 'active' : '',attrs:{"href":"#/software"}},[_vm._v("超算运维管理软件")])]),_vm._v(" "),_c('li',[_c('a',{class:_vm.$route.path === '/about' ? 'active' : '',attrs:{"href":"#/about"}},[_vm._v("关于我们")])]),_vm._v(" "),(_vm.loginName)?_c('li',[_c('a',{class:_vm.$route.path === '/setup' ? 'active' : '',attrs:{"href":"#/setup"}},[_vm._v("超算配置系统")])]):_vm._e(),_vm._v(" "),_c('li',[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loginName),expression:"!loginName"}],attrs:{"size":"small"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v("登录")]),_vm._v(" "),_c('el-dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginName),expression:"loginName"}],staticClass:"user-btn"},[_c('el-button',{attrs:{"size":"small"}},[_c('i',{staticClass:"el-icon-user-solid"}),_vm._v(_vm._s(_vm.loginName)),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v("注销")])],1)],1)],1)])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"登录","visible":_vm.dialogVisible,"close-on-click-modal":false,"close-on-press-escape":false,"width":"30%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{attrs:{"model":_vm.form}},[_c('el-form-item',{attrs:{"label":"用户名","label-width":"120px"}},[_c('el-input',{attrs:{"autocomplete":"off"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","label-width":"120px"}},[_c('el-input',{attrs:{"type":"password","autocomplete":"off"},model:{value:(_vm.form.pwd),callback:function ($$v) {_vm.$set(_vm.form, "pwd", $$v)},expression:"form.pwd"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.login}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Store__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Software__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_About__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Setup__ = __webpack_require__(322);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/store',
    name: 'Store',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Store__["a" /* default */]
  }, {
    path: '/software',
    name: 'Software',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Software__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_About__["a" /* default */]
  }, {
    path: '/setup',
    name: 'Setup',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Setup__["a" /* default */]
  }]
}));

/***/ }),
/* 166 */,
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90a01034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90a01034"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90a01034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header',[_c('div',{staticClass:"perform"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"banner"},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-boards","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-boards"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(170)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__zoomInDown banner-content-line","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-line-solid"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(171)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__zoomInUp banner-content-line","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-line-dashed"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(172)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeInBottomLeft banner-content-equip1","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip1"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(173)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeInBottomLeft banner-content-equip2","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip2"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(174)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-equip3","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip3"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(175)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeInTopRight banner-content-equip4","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip4"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(176)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeInTopRight banner-content-equip5","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip5"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(177)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeInTopRight banner-content-equip6","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip6"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(178)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-equip7","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-equip7"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(179)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-switch","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-switch"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(180)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__rotateInDownRight banner-content-text","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-text"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(181)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-tip1","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-tip1"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(182)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-tip2","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-tip2"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(183)}})])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-content-tip3","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"pa content-tip3"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__(184)}})])])])],1)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"high-wrapper"},[_c('h2',[_vm._v("量身定制的自研产品")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"software"},[_c('h3',[_vm._v("超算运维管理软件")]),_vm._v(" "),_c('p',[_vm._v("—— 掌握信息、运筹帷幄 ——")]),_vm._v(" "),_c('div',{staticClass:"admin"},[_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInLeft","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowContaner),expression:"isShowContaner"}],staticClass:"pa pay"},[_c('span',{staticClass:"pa bill"},[_vm._v("计费统计")]),_vm._v(" "),_c('img',{staticClass:"line",attrs:{"src":__webpack_require__(185)}}),_vm._v(" "),_c('img',{staticClass:"small coin",attrs:{"src":__webpack_require__(84)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInRight","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowContaner),expression:"isShowContaner"}],staticClass:"pa warnning"},[_c('img',{staticClass:"line",attrs:{"src":__webpack_require__(186)}}),_vm._v(" "),_c('img',{staticClass:"small alarm",attrs:{"src":__webpack_require__(85)}}),_vm._v(" "),_c('span',{staticClass:"pa fore"},[_vm._v("告警预报")])])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInLeft","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowContaner),expression:"isShowContaner"}],staticClass:"pa monitor"},[_c('span',{staticClass:"pa"},[_vm._v("资源监控")]),_vm._v(" "),_c('img',{staticClass:"line",attrs:{"src":__webpack_require__(187)}}),_vm._v(" "),_c('img',{staticClass:"small",attrs:{"src":__webpack_require__(86)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInRight","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowContaner),expression:"isShowContaner"}],staticClass:"pa work"},[_c('span',{staticClass:"pa"},[_vm._v("作业管理")]),_vm._v(" "),_c('img',{staticClass:"line",attrs:{"src":__webpack_require__(188)}}),_vm._v(" "),_c('img',{staticClass:"small",attrs:{"src":__webpack_require__(87)}})])])],1)])]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"partener"},[_c('div',{staticClass:"partener-cont"},[_c('h3',[_vm._v("战略合作伙伴")]),_vm._v(" "),_c('div',{staticClass:"logos"},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInLeft","leave-active-class":"animate__animated animate__fadeOut"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowPartenr),expression:"isShowPartenr"}],staticClass:"logo1",attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInRight","leave-active-class":"animate__animated animate__fadeOut"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowPartenr),expression:"isShowPartenr"}],staticClass:"logo2",attrs:{"src":__webpack_require__(189)}})])],1),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("\n          与北联国芯保持长期战略合作，发展以国产自主可控为基础，构建安全可靠的高性能计算平台\n        ")])])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_vm._v("高性能计算平台"),_c('br'),_vm._v("整体解决方案提供商")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main"},[_c('section',[_c('img',{attrs:{"src":__webpack_require__(190)}}),_vm._v(" "),_c('h4',[_vm._v("专业")]),_vm._v(" "),_c('p',[_vm._v("深耕高性能计算行业数十年，数百案例实施经验，遍布高校、研究院、企业")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(191)}}),_vm._v(" "),_c('h4',[_vm._v("智能")]),_vm._v(" "),_c('p',[_vm._v("混合架构，支持异构处理器，支持各类主流作业调度与并行文件系统，不限硬件，拒绝绑定")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(192)}}),_vm._v(" "),_c('h4',[_vm._v("简单")]),_vm._v(" "),_c('p',[_vm._v("交钥匙工程，从基础架构到上层应用，一站式构建高性能计算平台")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"high"},[_c('div',{staticClass:"high-left"},[_c('img',{staticClass:"bg",attrs:{"src":__webpack_require__(193)}}),_vm._v(" "),_c('img',{staticClass:"equipment",attrs:{"src":__webpack_require__(194)}})]),_vm._v(" "),_c('div',{staticClass:"high-right"},[_c('h3',[_vm._v("高性能存储")]),_vm._v(" "),_c('h4',[_vm._v("CompubiqStor")]),_vm._v(" "),_c('p',[_vm._v("— 国产自主可控")]),_vm._v(" "),_c('p',[_vm._v("— 全定制专用存储系统")]),_vm._v(" "),_c('p',[_vm._v("— SAN、NAS融合型存储")]),_vm._v(" "),_c('p',[_vm._v("— 高可靠、高可用、高性能")]),_vm._v(" "),_c('p',{staticClass:"more"},[_c('a',{attrs:{"href":"#/store"}},[_vm._v("查看详情")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa professional"},[_c('img',{attrs:{"src":__webpack_require__(195)}}),_vm._v(" "),_c('p',{staticClass:"profes pa"},[_c('span',{staticClass:"title"},[_vm._v("专业")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Professional")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa modern"},[_c('img',{attrs:{"src":__webpack_require__(196)}}),_vm._v(" "),_c('p',{staticClass:"mo pa"},[_c('span',{staticClass:"title"},[_vm._v("现代")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Modern")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa graceful"},[_c('img',{attrs:{"src":__webpack_require__(197)}}),_vm._v(" "),_c('p',{staticClass:"pa"},[_c('span',{staticClass:"title"},[_vm._v("优雅")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Graceful")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa smooth"},[_c('img',{attrs:{"src":__webpack_require__(198)}}),_vm._v(" "),_c('p',{staticClass:"pa"},[_c('span',{staticClass:"title"},[_vm._v("丝滑")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Smooth")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('a',{attrs:{"href":"#/software"}},[_vm._v("查看详情")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("高性能应用容器")]),_vm._v(" "),_c('h4',[_vm._v("CompubiqContainer")]),_vm._v(" "),_c('p',[_vm._v("打包应用程序，开箱即用"),_c('br'),_vm._v("\n          去繁就简、解决最后一公里问题"),_c('br'),_vm._v("\n          原生支持MPI与GPU"),_c('br'),_vm._v("\n          支持宿主机作业调度与并行文件系统"),_c('br'),_vm._v("\n          安全增强、无需root"),_c('br'),_vm._v("\n          平台间可无缝迁移")]),_vm._v(" "),_c('span',{staticClass:"icon1"}),_vm._v(" "),_c('span',{staticClass:"icon2"}),_vm._v(" "),_c('span',{staticClass:"icon3"}),_vm._v(" "),_c('span',{staticClass:"icon4"}),_vm._v(" "),_c('span',{staticClass:"icon5"}),_vm._v(" "),_c('span',{staticClass:"icon6"}),_vm._v(" "),_c('span',{staticClass:"icon7"}),_vm._v(" "),_c('span',{staticClass:"icon8"}),_vm._v(" "),_c('span',{staticClass:"icon9"}),_vm._v(" "),_c('span',{staticClass:"icon10"}),_vm._v(" "),_c('span',{staticClass:"icon11"}),_vm._v(" "),_c('span',{staticClass:"icon12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"about-left"},[_c('img',{staticClass:"bg",attrs:{"src":__webpack_require__(199)}})]),_vm._v(" "),_c('div',{staticClass:"about-right"},[_c('h3',[_vm._v("关于我们")]),_vm._v(" "),_c('p',[_vm._v("南京信易达计算技术有限公司成立于2018 年10月4日，注册在中国(江苏)自由贸易试验区。信易达是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技企业,拥有超算中心建设、部署、运营的自主可控一体化解决方案，产品和服务覆盖政府、军工、高校、金融、医疗及科研等行业。")]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_vm._v(" "),_c('h4',[_vm._v("025-68155007")]),_vm._v(" "),_c('p',[_vm._v("南京市江北新区腾飞大厦A座4楼")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caser-warpper"},[_c('div',{staticClass:"caser"},[_c('h2',[_vm._v("客户案例")]),_vm._v(" "),_c('div',{staticClass:"case"},[_c('a',{staticClass:"small",attrs:{"href":"javascript:void(0"}},[_c('img',{attrs:{"src":__webpack_require__(88)}})]),_vm._v(" "),_c('a',{staticClass:"small",attrs:{"href":"javascript:void(0"}},[_c('img',{attrs:{"src":__webpack_require__(89)}})]),_vm._v(" "),_c('a',{staticClass:"small small3",attrs:{"href":"javascript:void(0"}},[_c('img',{attrs:{"src":__webpack_require__(90)}})]),_vm._v(" "),_c('a',{staticClass:"small",attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(91)}})]),_vm._v(" "),_c('a',{staticClass:"small small2",attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(92)}})]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(93)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cont"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("地址：南京市江北新区腾飞大厦A座4楼")]),_vm._v(" "),_c('p',[_vm._v("电话：025-68155007")])]),_vm._v(" "),_c('div',{staticClass:"qr"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"spa"},[_vm._v("关注我们")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('p',[_vm._v("版权所有 © 南京信易达计算技术有限公司 "),_c('a',{staticStyle:{"color":"rgba(255,255,255, .4)"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("苏ICP备2021021510号-1")]),_vm._v(" 苏公网安备 0000000000号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/boards.ba0fae5.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/line-solid.147b874.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/line-dashed.34b0843.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip1.9966d6a.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip2.9eaac56.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip3.5e735cc.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip4.988d310.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip5.1dab6ce.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip6.15b6979.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/equip7.3dee1f3.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/switch.4bc491b.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/text.6aebd03.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-content-mom.f81a565.png";

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWYAAADQCAMAAAADHDv4AAAAq1BMVEX///8AAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+x5Xr9AAAAOHRSTlMwAO/6VZ5c2Dc89WrpZEV6QTTmrG6jjL2o0pjhx7nVhX62YN3rwkuCWM0Xk3GxUS0m2nUGyYkfDsvUTpAAAAyvSURBVHja7Nppd5pAFMbxp+ACLigad407Jm4xxqT3+3+yDhcGQTGhpuYc6vzeWKza03/nXGZs8Cvibfmx271A+YaX3e5j+RbtikjjHZR/ZMelYzIv1Sr+p16WMZl/q8j/PvTv08xLKDewjGb+gHITH35mVfmWZGeoiXFjS5n5N5Qb+u1nVnuMm3pxM6uRcXNLN/ObWsw39vL2C2ox395SZFbfY9zc7hfeoNzcG9TM+AFLqAPgD/iAGs0/YKcy/4Qd1K759lRkRVGUO2UVm5s1bsacLLIj3DtLI+EVt9InoYe71yZXERfVtAQmuGBPrhwuG2sRMwh5LaqMtDN5OT/jogIlcLnDlIQ2LptThA6hRFFFpE01c6JBrn3mhHVV5nX+1IyEQv7U+j/PnKVkGldlXlBCC5U5JrN+RGfX38/ce2CDcObDA2veU+YqpAoJfRxN/0HmR7BsOPMGLKcyX8hcevxU6W4y9wZfqlyfuQufBXZy0b2bzA0kd33mYWFjQxrrWfNi5l6RRWZzv8jeVeZPM1t9IpobYPaYiLShzZnvZqdxktm4QeaKRq452JjY9OFuM5uVlm59lbnyIDVIyD8clSLHk46wAMwBsWcLzGmR5/CEYkPI3Vnmsk5EIwTG/eb2u4dte+F3ytqQJh3y1A1E1HsRUwgHeVXQ+WGCtDnNXCVhjMCMiGqT72Q2hn5kjRdhuVjkR1T8p2tlXNae11cjE8xZ5UnfIpWOmcurYLZqkBxyOddnNpolCg0Me0PCwIZgNnRibQMXFEnohS8OSCU/87Y982u2SXiCb0RCCddmNlYz8uhdvp4Ta9lwZTrELk0Be0rhEcb/RHukkZ95T8IKwPFXrM4z5Opb4Jx8YweC2SHf3AZb6eHDdq4e5b19Iy8HJMzqLIdU8TObujx8VSPfN0+5wdUbOksjV/8JrqcpBToOWCbPf54pPyypClKl7e9s+8EMfiUi3QTj5uRcnZnnaaccWbnNBT8WFmDGRlQ28J9n5nnXBIbeowxfBNt7o/n6zMhO12CONzD0PbD2ereqYIu5gf89M8+7IWCRnBprXt+h0by5OvOR3SyQa8Yztax5F0MbEcV8oEdM8y9nfNXLB1J2QpnLpZGX46EaClcjYfT9zKMasamcyDNivQrijUrH1x9vnr3U/l/rgYS1/GqhKY+2Bbi2xO2/m3k9JU/LhM95Jk/ssiy+EjuYkIw+uTYOUqkjqzx5veQC3wL+wK7hPPNjR+qRUOgc6SeZ7cojeUprhCw08nRGBiImB/KMbRzZA3Lp4wxSqEZCLljEtlzXoyD4BhGUwDGz09DIVzcRUR2TT2s4kLbdGnkK74hqFojl36tIGz0YC7xaJvIeWAdgFM7v6ebfZN4fSJpOcKbYI6n/AMFq5kkaWzhlzcmjP6/StaYtEnQ7mBBd+VwewAPJLfSR8zeZGxToPMd4pEDX+1EcaVpGnP2MfHqqVvTkOH0zwfFPIyLd8PfULUTkSNBfAzUSCq9H4dls9CihqQ1hRdKsJG2Bp1JAI18baVKR33qF6qLvzWtbi/mqZu29IeFOo+y+eL+hz7x35N0BRo3OZIAcndHTteNYeXOYzeXxL9ur76teIyoYiOjyUkqaGdmGA7TpMya27W7waZ3u15kLA32MVBmQsAolz0Ly6gzifnJ2mDjz8YOex+c0L3OIg+rXmWcwUzWZgVJoLzGJFrNn3sklSuOKV2R+wLnOWWZ4mZsT1zCceTRhG86cMg65trLr/H2LwDpuZmy9zcetMxfhmoQzP4F105iZI2mI1Yo5myDrbUdU5uRkgBbiVHX++8YNmdVnmWsqsxRt0kScJi90GxFlcj19ktkilfnUhFw57FvnZiTM5FUjtM+Y4nJmI+t95HnmkXXu8fPM5f8kc90/aq/oK17aNbkWsZkzhVnv8aARnab7et8c9uWGLn2ZjYI3mpNmtns8SIzYzJiFO6jMR1UezevEmS1+fRfxmccUGKrMYVae73JJM8N6JaoZFzJXSBpAZY4w+9R28+W+kgEzn6mICKcilLlPyVU71MuIy9wenqtdyvyecy3CmSs5lspTIOxxDn/DXiARtaH7ebYhJP6N0HOGIB8jb1EURVEURVEURVEURVEURVGUP+ycbZOaMBCAdwCVF0WiBTn0fEEFbgRm6sgM//+XFTabhprDu3Zaetfp84VDgWweNzHeJPknMY1rdR1b8FvxjAZTnlvteW8Z7myXOiX8DAxeoWwK+Zj7PGRPNWKHLvxGRnfzvvZiUZAKi+wa2c7hveSTrG+K1AI+HszXa8Gp/Cua46Oyld1bONu6/lSao7rD1PsLmj2t7nB5Z9CfS3OCuayf/VvdEv05zcxqYH0L7+v1sphi12XB24S9mq0W+HDgWhLcsXouJ2WZ1+hwuOQ8teMgCHZg7cNDUAKYe381yuTr7r5YpnihEzR4AF57nAnNSXBY7rDeZdBQonDHL/Yu7JrzGCCjxapizXUASgiz5soUzHzEiy6DF+xfgjl/bvh8XhUXF1pSvBQYL8yoDkXFgBNX4bkYOfw0aMi86lAlMASabKjF6hKj5Vxs75SLBqqVa0z6mbvFY0rZqhknzMQ21mV3woRPmgsbF7vFstMQ08VOmcZXsVTy4zW24TwBNQS/fYbHi64ArjUxwT0BCT3sdBoWFsY35Th62GzPNWeBJWC1jxjBAKhbjvwwi8snzbpNtT7xo+1xjeL1qdmjmdAsqZnd6Bk6r2SIyQy9IZBmbUG3uT9oLmrJ7k7zpPOIBCOVnjHqtgYuDECMBZvQIdPb0p/5KC9GzSr77xp52lW9mm1eU6k5kLeh5g0de0NAzZK0q9lqH6/tjS8azeGTmiVT2kRBr8pAq/kMPzmVbwgwYl3trR2xhpI0Lxx3gtLmJfaLEWlcZ7xPP/ZoPs1ohwKpecXXZRlr0nvE9vsgBNK8yMsb3WJiWWOTATOcNHIATNRo3mleJns8Mp5OIVBUOWmexK4LQxCr8y2nmCa0R4lNmn3gus4ADkU8Eu209a73aF7SnGadkWYu4gkAduTsRtc/CMGnoub4yPuRhhkHK95mPKlZZDF+mC5UWFie5xeKnpZlDER3Mdro6VJSb70CoLRzueac6hgAGF3Njpiz7L6uORerNxOh2RJdsUOaC9l2vUWRm6+E4JOTTNXMqhe9RlTNL/QECk7yzDXbMBRME6Nl3s0tEqaLPWc3mIVc84w07+40V6ImHiypI/3S1Xyl92U2C4eUYHS0LRDftiNQQvBpqYqhaGZbvHu1P7yi+Sw14w26TWy45gUMxkiMm1lIfWwb+MkEYCc8f6x5A8BoP56Q+tiwqzmk97eyb7bb5swAzqTZwmwsTACDltkrIaia6QXYiXvPjzVX9+thaKAyFAlvcl83UzympGdllCvS8FBzfU4xn55oEGYvX+quZr244guF1PyENUzPYqRBDVq7bTGUBVNCUDWP8I1yDEsKrtQea3b1NkgGMA+jXe4CUNADgfYkaxPAnHTPH2qW5NhZEOq4WY+l5rwmhGbz64/jNSUEVfOuRm78s50EoYbnbp9myv+v4Q0/SWt4zRDotWDDfy+damKdwRua8V7qSMlNNJWa7Wfxw0FqhjOpF5oh2dYC+wpqCKpml2s94h8ItpGsXzN7qQWnDAbVTBgHHus0Ao550fi5CW9pvhZ64ybibm5tFVPoaNbA1xobF+hqhshuJB+u8mcJC7ho/WaoISia5V6AJ4Bx61effMEv8KhfM7DLmksOPRhcM5GMnTiBDtY4s973HzgzK0HgxR4oGC4olJkpBnSEZcxmhvX+EJghLnfjksG7cLNZ5sIngzT/MqT5P/81f2PvDk4AhIEoiO7vw7uylwQCsf/OzN2b8BcD80qYBuYHyFziPJYrPruO5YxdsTMv0QNvZN7TDBTIQIER8OsK+CWZC7RB5gIpMvs1kbnATeYCKTL7TZHZb4rMfiky27VbZHZrKZHZrOcQmR927NiGYRgGgCC4ThqpSvbfLIA3sAB9dTcCweLJi9be32fGp2Pew5l3b9PhzLsG5P6Yl2UuxvwZ7o95DcGYf8MxMZewzAkxl3CZJMRcQswlLHNCzCXEXMIyJ8RcwmWS8GZOiLmEyyQh5hJiLmGZE2Iu4TJJiLmEmEtY5oSYS4i5hGVOiLmEyyThzZwQcwmXSULMJcRcwjInxNy/HTsmAACAYRDm3zUuchENO+iIlwlxzBHHHPExE8ccccwRHzNxzBEvE+I3M3HMES8T4pgjjjniYyaOOeJlQhxzxDFHfMzEMUccc8THTBxzxMuE+M1MHHPEy4Q45ohjjviYiWOOeJkQxxxxzBEfM3HMEcccEWYbag/NWx0DAAAAAElFTkSuQmCC"

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABCCAMAAAAlrWkSAAAAkFBMVEUAAADg4ODg4ODg4ODg4ODh4eHk5OTg4ODg4ODi4uLs7Ozv7+/g4ODg4ODg4ODg4ODi4uLl5eXl5eX////////g4ODf39/g4ODg4ODg4ODg4ODh4eHg4ODh4eHg4ODg4ODg4ODi4uLi4uLi4uLg4ODf39/f39/g4ODg4ODg4ODg4ODh4eHf39/h4eHf39/f399bSwqGAAAAL3RSTlMA8PTXwEIlm/w8DQf55d/FIhwWBAHq2s24rKCIf3FfVkY0KxGV0bKlkHdqZVBMMGrl2MsAAAFgSURBVGje7dpZbsIwFIXhE2eeCiGEMEOY57P/3VVUVavyVniJj/h2ECn+49gXX/zQNWYQ+rBb4PFbpwuLxQ5/ODGsFTjkLyeArTz+4cFSPh/YuuJDPhjDTi4fuLCTYSu5iciDcFhKvFrdnKHGYm8MZxr5XTC6aHwQjzSNxhYlZF5IbBpLj9tEYhu/dv8R4Vb/WHUrbiAhzjiDhAWjKyRMaW6QML5HWEHqsU6gYD3grg8FQcUDJMQZT5AwZ7SEhCmdFSTs+dGDgrTDOoWC3gdHIhF2OIEEP+MZEnQiPFGJcH8kFOHOO8LtspKJ8DLiHBLOzNp2avWkSZuOdd8RvktroQjvIWHlcAoJOhE+MWvRTc4rDqxEIrzjYA0FSU1PI8JF3pKRgJfdjEqErxEXkDCTifCGVasu1J9WDumKRHhLr4SCImcICY3hERIuQhE2DSRsmOtEWGOmIHFdjTEPFAk+AQClct9zDLs8AAAAAElFTkSuQmCC"

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALYAAABCCAMAAADNLdw5AAAAkFBMVEUAAADg4ODk5OTg4ODg4ODf39/g4ODf39/h4eHi4uLp6en29vbl5eX////g4ODg4ODg4ODg4ODg4ODi4uLj4+Pf39/g4ODg4ODg4ODg4ODg4ODg4ODh4eHh4eHg4ODg4ODh4eHg4ODg4ODi4uLh4eHl5eXn5+fg4ODg4OD////g4ODg4ODf39/g4ODg4ODf39+TDvApAAAAL3RSTlMA2Cb0m/HuwUM8DgYdA/r338XUIhfp5dCwqKCSiHFjWlJKQTQuEwqAeQHLvbm2aqbT8LcAAAFtSURBVGje1dpZkoJAFETRZFYmEQScRXGecv+76zCio1v5Ub4kzxKAuvWoKKjo2YZlGXYPSrIhf3kmZPQd/nH7EGE6fOKqPG+PLzxI2LBBY11O2WBDgcEGA635Kb/OQlvRld9noS2beYg3uveRLDio8VbXlmRFVvhAtwJYWzziQ93ZbsKixevpzObul7wE+FhHRqnoxtRHC90YXGfMM7T0/d+EBQcyg+6/NbmCnO0jfXLCglPI2Zf0AqiJxjR2kDOjm0HOXTN9sWT6HB4gZ5RwAjn7M4eS6UsE0zfXOXB7smS8gZxezCXkmA7nkPNI3wlqgqFi+k4TJiPImdPRTJ/Gkf2LjWb6XMX07RKOJdN33kOOZvoOdLaQs2K8hpz+gHfIMV3OIGdncBxBTeCxFEzflIVk+izJ9FEzfQvIyXLF9PkGb4Lpu7D0IcdmEULOkVYNORVZQU4tmb4wF7lY17whd9VLH8I0FUwf4Aum7we4bG0tOvbXhQAAAABJRU5ErkJggg=="

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAABECAMAAADdsaudAAAAjVBMVEUAAADg4ODg4ODh4eHg4ODk5OTg4ODg4ODf39/g4ODi4uLp6enq6ur////g4ODl5eXg4ODg4ODg4OD////j4+Pg4ODf39/g4ODg4ODg4ODg4ODh4eHg4ODg4ODh4eHg4ODg4ODi4uLi4uLi4uLl5eXf39/f39/g4ODg4ODh4eHf39/h4eHf39/f39/f3992Jcn4AAAALnRSTlMA9NdCwCXu/PGaPA4JAecd+cWfBRfe2s23sJKIf3VsX0o0KyIT4dGqpWVYVFAw8sjejgAAAWNJREFUaN7t2keSgzAUhOFGZIMBG+Occ+z7H28WuGbG3mknd/m7ASVKvwQPX5+ozCArM6aEqHpMI7t0KQvZhVvQ20DUPeYNojYeFxBVFuxDVHZkUENTVzkCUxY7iFqy6kDUOuYVoh4e5xClHIF8JByBCYd7iJoyCiFKPAIriNomuhEYHHiGqHzEXg5N3Qkb2QjMhCNwYeVDlK8dgRlEDRqeutCU94QjcGIzgKgZky1ErRjrRqDiBaLCSDcC+4YT4QiMVCOAMw+yEZhrR2ANUZ2KS4gKI04haj/UjUAdCEegz0I4At4Doq7fCPzxU+N5w/QTrkY7ywiEAZ96zg85ZIZjmwh0Iv5KHP/DVQc8Znax/ydx+7N033KMMuCLAA6zHaP0+cbhXeXG+A4bKV85PMhhP0Zp+MbAUWXBFHY8fo5xrftwJgNUX8uW6obSUk1BSzXiLdXjV0v04NxSvfK0VC+rX08/Fjx36BmNpQ4AAAAASUVORK5CYII="

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQYAAABECAMAAABUDGvdAAAAk1BMVEUAAADg4ODg4ODh4eHn5+f39/ff39/g4ODf39/h4eHj4+P////g4ODg4ODg4ODh4eHg4ODi4uLh4eHk5OTl5eXf39/g4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODh4eHg4ODg4ODg4ODl5eXk5OTp6eng4ODg4ODf39/g4ODg4ODg4ODh4eHf39/g4ODh4eHh4eHf39+HIS6MAAAAMHRSTlMA2fREDwbx7sE/JAH698WemjkwGxbp5d/U0LCWjXpxY1pSJiALy725tqqjhoFqTCpxzuAaAAABaUlEQVR42u3bSVbCQABF0ZeWJEiPCraI2Cv8/a/OA6InIA5wmPp3DUm9arGtdIQxmkxSLJ3oKcPuT3WJMejoBuNOusO4VjzE6OnM2YTsUVNnE9JIz23M2XQ262bSEnM2nc26rNB0gaWRLpxNqFq6wig7+sCY6STBeFfubAKvOh9jWVcPziaMnc2NubO5UZ7oFuPW2dx4U77C2i/O5jabXZ/pwfhcL84mrHK9YSTO5nc2S4wrteZY+0KRswmLB2dzm81XjGGud2ydzRnGhzrO5lc2K2ydTV+FgcVUhbMJozP1MIaxrjGWcjbXbtQZYFzq9J7mSPpRHEf9hCO1nxuUzaqrraLiOOlUjw3J5iDXj1YZajbnuWpaVaDZLLSjCPPhRak9SZDZ7GlPP8hsRtoTcazsSc0T/+u9YuPEhOjATxGiA0NkiErtCfRiz6/pU5h2JtMB7zfvLK0CPn2oLbSD/Rbq2y6Bjo5/+ATe5IyfhnilvQAAAABJRU5ErkJggg=="

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-bl.65f0be4.png";

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAYAAAA8uqNSAAAgAElEQVR4nO19CZhcVbXuv07P3enuzPNEEpIQpoBhMoGADALqRUVFr4L3XvChzyvqewhPREUEVC4og1fUJ6CiIiI+ByAIQmSSMCUhZE7IROa557HOet+/9jld1X066a6q7hqw/+/rr7vrnKra5+x11l7Dv9YW/BOgMabj2tsw0wemi48ZCowXQQWAKgUq+VsUgyCosruhqFVBPYBaAer4WxUNAmxVD2s8YG1hEVaXF8i2d/rde8cJSG2LzvQVZ4linipmQjAdqoMiJ/YFROqhWCuC1Sp4wRMsrCqR1Zm+5v5E3gtIU5NObgPOUuBsKH/r2MhJGYRAtkOwUICni4CFZWWyKZvjSRd5KSBcMlpbcZkAl6rqUZETcggiskqBB4qL8ct8XJLyRkBUtbKuGR/xgUuhelbkhHyAyEIPeKCyFL8Xkbq8GHLklRxDXYvO8n1co8BHoVqe6+PtFUQaBXjY83BrZYmszOmhRl7JETS06olt7bgO0ItzdYx9A3mkqBC3VBTL4pwcXeSVLKO2Ueeq4HpVPT/XxtafEJEnRHFTVbm8mFPjirySJdA9VR93qeq5uTKmbEBEnhIPV+WKu+xFXskwVLW8tllvUR/L/tmFA+5+nMt7YfckB2yurGqQ2ha9yPdxJ1QnRQ4OgOpks+fhi1Ul8qds3Y2sCAjjGG0t+LFC3x85OIAIBPJoUQk+m404SsYFpKZZL4CPBxQ6LHJwAIeEQPbBw6XVpbLgUOf0BzJmg6hqgbM19PEB4UgevGe8d4FtUpCp782IBrElpRUPqercyMEBJA0RebGoGJdkYsnpdwGpbdaz1cdDA1qjb8ElRzxcUlUqT/fn9/TrElPTqB9XxYIB4eh72JKjWMB73J/f028CUtOsVyn0QVUtihwcQJ+A95b3mPe6v+5ovwhIYIzeGTkwgH4B7zXveX98dp/aILSua5rxE6heHjk4gP6HyL3VpbhSRGJ99V2FkVfSwIBwZBmql9c02zN/RV8NpM+WGFNxA8KRfahe3pfLTZ8sMWaQDtgcOQXx5IvVpXJXumNKW0DMlYU+GDkwgKxDIJ+oLpffpjOOtATEgmCMcwy4sjkJEWkTwQXpBNNSFpAgI/vGQBAst8GIa1EJjk81LJ+SkUp31nIrA8KR8+AcBXmwlBJ8Kbm5dS349jsh8eYr0NgO7GgA3q5THGxxKnVwCTC+UjCmAigvBLw8Ly/jXNW1yLcBksCTQ9KXTj4H086RA3mGVp9CATy+SfHrVYrV+9VdgNhjhxlDgIuneXjfFGBqtaC0TyNG2YF4cmGyfJKkBOSdYnfUtwGv71LcsUSx8G2NHDf4bgE+erjg/8wRnD5OUF2S37WqqdgjSV1vTaP+Jd9pgnWtwFNbFNc872NvU/CiKqqLgZnDPBQVAG8d9LGjHUC7ADG3zHz3dA8fmCIYUhL5yLwC6YvV5fKB3o651wJiBOOY/jFyII/QHAOe36a44skYalo9W0uKC4Cvnexh3jhgZJmYvXGgWfHyTuCWxT721TpNwvN+co6H904UlOe5U+8VyAd7S4TulYCQfl/TjJX5zD6nQbpyn+LKp32s2OuufEgpcNeZHs4cL6gs7nx+Qxvw6i7Ftc8r1hxwy9C4QYJ7zxW8a5SgKOsFI2lAZHN1KWaJSGNPH9Kry6xrwfX5Xpqwvxn4zWrFin1OOAoEuGO+h/dMiAoHUVEEnDpG8F9nOG+G2FavuHupYnt95PT8guokm9NeoEcBsYo3xdWRA3kEeiyv7VL8aJnfMegbTnOao+Iwy0VpAXDSKMEtc73AagUe26B4YrOaoZvfMoKrObeRA13Qo4AE5ZCHuY25izYfqG0FVuxV/GCxdqyoZ00Q/MsU55X0hLJC4IzxgqtO8JyMCPCDxT7WHlBbtvIVxkbz0WMy77DePQup/Twsh6Rg7GwAluxWLNyqWLQDWLU/PCr47HGCsUk0paLn8rEjPTy6CdhwULGzQfHntxRTqsWCavkKlnlyjg9XMH5YDcIq+8iLOQ4Kx7oDim+/7OOyJ3zcv0KxyoJg7nE/fgRsYpMxMunZTB0s+Mwx/JiY3Zifr/Cx/qAij5WIoac5PuRtYn+OfGzBsLsRuHOp4nfr4lFR+xE3lW/sUazZr2hJkpTHSOrpY4FJVZ7dNYbln9sGNOa9LaLnc64jBwIcUkBc85b8QrsPvLlX8dAaNSuMQnHRNMFXTvIwa2jco//xm4pdPTp4ncF3T6wUfPhIDyjgZwt+u1qxLd89mh7mulsBYdunfOzs09QOPJsQRD53goevn+Lhiyc4TyT0WBbt8LG1LvnFge8/dyJQ0er+X1sDy+G0+5FT8wx6sZvzKLoVEN/HtZEX8wAxpdcSn/hxlcDQUjexo8qBEaXu9XZfLKqaLBg7of1y5iQBmp0m+dvbap5SvoN94Lq7hIiAsJugAh+JnJkF0I1kDIOT2dzuNAR/83/aEHxyE11Nxi2O5lISLC+PblA887ZaYu7PG4BNQV/BEWXA8LLUrmdwMXAGBaSszXI1z26l3dO9NtJg2eNYu7sGXlus+7dmHGwSyLnv+r0RN5etJrPZTZBeCG/ivibg7XrFxhr3N3kb7eqe4mIPFv0cWQZzV0eWu5gGBWTOKGBClWf8Dibjrvibb4m4moSn/GPTxcLmqYA5mRNHAVXFBahtBjbXuZ8jhzhhbYsBTTEGGIE9TYrtDc7lZpKQQhELroHxFWq3yZUcr5jAUtPRu8pKxli1vK5ZqBjuT3w5IiDWhzQLoGBwQpftcSn4F3eQo+FehyZkjdT5Zva/qN3o8YM4QYKZQwQTK4GPzwDuXuqeVJ5f0xK/nrljBZ+YkXr8gi7vhEqxMPyTm9Q+/4lNLlaysxGW52Huhj8U0vq2YOAiFnV0vwP1KIICz/FNThoDC/szcju6wj0EmUYw950EpJOwWgfjFt2a6YFxIt/cp/jpMsUf1vuI+cENTRxlRBVrN7lGNwmVJWJHEm2DYaXAJdMFn5gpmD5EUJJihw0KLDUaw/Z3LQ0MHwEGlwoOtroYdgQm0N283hUiOG8i8LnjBXNGdp8j6m8Ul8j4RL5IJw3C9taZHhCF45Vd5GeErC7pmHfyMCZXC8ZWOBog/6fsMPbA5Nv2BsGOBjX13SFFIsH/wWR5HjwojhshmDZE7MGl4HBJ6u1TSqHgZ9LWWHMA+NsWCnIw1uAzDrZ0ZqTxj7JCxegKwfgKYFiZy/sUeu6aGUehxtlUq3ENp4ont7i80W1neDhvkmBQhpMcgQx8J/y/0yNY06QrM9n7nA8fA1f/85kEyp8CF04RXDRVMKWa67SgotCt/QXBaGmLtMZcSp5eC4Xl7Xrg5R00SIG3apgnSVyT0PH3mEEe5o4BLjxCcNxwJ3xlRVFdhIA/wsAbaQKPbVTjknBCuz9bMb7SMxuIy8TUagoFbRVBZZEbf2FgX1DIOX4KOgVrSx3w5Ga1bHM4WhrS957n2VKWyeWGveWry6TD5e24Uu6a0KK6MfKOfgRtjptfieH+lc7zoIa4fb6H+eMEI8qRVDg8fMr3NAFb6hRvHQRe2al4cbtiV0PilQaPuCqOHeHZkjOPEdJKp9K5slHwGCd5bRcpAj7+sVPdMtEd+Lrn40NTPVw1W4zsXFWMpJYwPigUcgr4tS/EguCb4D3jBT8408Okqshb+hUlIkeEu1R0LDHcUiOzwwA21ioeXucD6tnMfGeey7IeLgV/KFCY6BVwYrbUKtYeBE4eLfj0LDFB5BP6/DYf2+vDpUDw5l7gzRcUYysUH5tBwXRPOQXjV6spZNpZAylMcOePF7x3smDpbsV/L1WLFjS006MSe/KTBTUj33fORMF/nV6ATy3wTcs8s9XHqv2CSVWHEM5+QiALZqx2CIjtt5JhbK4F6luczXHUEOdhpCIciaAw/HCp4tmtPiZVF+C+8wSnjRWb1F2NglX7gMc2qdkRdVQ7KuaK3rHYxx2L6aUkLE/8FStAcaGPsyYKLpoiOHqYEwTaMFw6/vsN58ms2e/silFpBAiY7zlljOAj0wW/W0t7yrPlJ9MIZKGzgHAznkwPZF9z3Fvh2p3K09cVu5sUr+02jj92NCta2t0aPtyCY2LxitPHCzbWMHim+PEyhR+4nDDvM3xa3bJ36dGKi4/0MGOIdGioECPLgaoSQW2Lj22Ngv3Nh7JPeg8a4yeNDgSE+6C1ZSEqkiALtsobaywLOzXF/Pj9HFSUnM1xKPAppro3zqmPCCmIwlIWFEPxx9euQRZ0+luDJYBPd9fx0YCeTF5Jm1j4fmNtELdJA/yuigTfMhukJMpCyDYrDAaRlQ16zM8PbgCXhhYfSCeEy7C2ZWk58/WKSWO4FMSfQBqf5HA8uRm45w0f+829lA67de44zzTE37eGy4ziV6sUf1in+I9jnH00c6gzQsPxzxgLLGPKfx9pBGJh9XQEnddwMCGwV5AlcnQgE6tNQGwDwMgp/Q9br4Mg0rK9LgCVTt0J3VLaAvbYlQJTR7nYCSdtaz3w9BZXLGWGKi845h4RUhA/OdNFMWmkLtur+O0aH39a79tSxTA/7RoKy3/O9vD+I4DJVYKyAmBKuQBtTgttrlU0t6cXu2BKgGz6EJmOg4SgTAC4xwTEdofMAhgiHzNIrTaWE8sbzGxpqrWwjYGGgHMsjAXGyV20U3HXYh+LdgYn8ngxzHi9bJqYcUx7ojSwL0aUC2aPKDDbg0Lx5Bb3mYyU3rTIxx9WCb58CnDqaMEoZohZgFXkY2ejZ/GNdMA4yzNbEjLS/bNfZ48IZcKtdrZ1aOYHMapCcPpYwe/WuezrwrdhNSep5kmY5KNH4sCIqnNDf/JmZ4LxMcOBzx7nmWCMGRQXjBC0U1jqcP5kwYkjBYt2KO5brvjHDhdWX1mn+MxTPj4+w8MEy386DbK3SS1Rlyoo4OTPholFBtuOqM5SsSdlggIS5F+yIqdcwxlPMHogFL9cpfjAVDVVn4oW4eSYZ2TwceeSzh9Ct/TqOZ5N/KRK9FiQTUGhlmPJ5ZxRYknEW19TC+/zDv52TSh17nsONHOSU/dkNtQ4YTYo8PHpHsZVRE7LDFQHUTY87kidpSHYBFBjnBb4T7Wtgj+uVxxoiZzaI9TqbtXKJg1dIp8fnCp48EIP/360WOV+MtX6NFwnVzmawK8uEFx+tHSTPKSAiBmYqXgezA8t2MQgn/ufEdlzJiHtuFA6oGx43K48e0OApbZpIDoo7lmmeGmHJsX4Yqia4fRntiASNxg/SHDP2Z5RDhmE4g1PlajD954wQnDtSR5+cb6HY4ZLR0EV7C8ff9mgZhAnQ0OMBWWhdy8JuA0CfH62yzpnszcJZaMw2Ms+a+D6f8Y4wQVHCBZsdCO5/XW19Zc3qKCHG0QPhUGvX6x0wtUBBT40TexGHzVUrGqf1XDM0+yoh73G4Fkq105BoeczbTDwi5UF+Omb6LBDfrrMN23wueMEM4ZKxL7pDhRulmdQg9IWO26Y4OwJ6UeV0wVlo1CB8dkdhjMI/8cxgufeVgtyLdkDPLBKjWx8uNA1jbrFuxW3vEoDsvOxiVXAl04UHDVMsLcRZmi+tlvx9H5gxy61vAdd1WSXA/OgC2Ehd9pKjI8s3ePjlR1BNJZs97WK5fuAG04FThl9eF4HE4wLNiseWhuQiaBWxTcxwwm67kDZKBRBVXccl0yCgaUTRgq+dKKHm192avZHS9UYYtQC3d1grvUMaF37gu+ytR1wTyF5GORg8Nqe26a4+rkY6vmE8uMLYMGv1PSHA8Pu3zvdM1fZDEnxOrLEHMPyvYr/eFJx81wP753ktFXX5YLa7/XdihtfDtYj9fCpWYp5Y3unefoblA1eVZY87c5gdPLiI8V4Go5OKPjmS76l7I06GIDrNTmezFVc8VQoHIIiAaZVxxld7OFRGNiS1EqN7cHnhsIm6f00BMRjLxDwkCREt7TcRZdsqfnCQt/yPUy6JdoltINod9y4KCQMeThqmOIzx0jKhOp+wCAuMTkhII7rCXz5XYJ1NcC6gzBv5roXFXed5TQM7RFmgP/vch/3LIsrALqs15/qYfEuxfqDLkNbEeRbOHm0cf73iZ5FKJc0AXX7FbOGiQWhktWePL2EGm+U2JNeUuiE0S0PbZg/vgBnT/Rw++s+lu5x7/n+Yh87GgRfmC0WvOO4WN13wyK1JZKoKgG+dZqzWwpzpPcIZYOyngOrnQMn85hhgm+dCtMOtDFI8bvhJapzR+phBtYJh7uxZ05wPcQYgV26Jz7bdE29oA/IEVXAF04QMwJppG6qFRw/3GV3ewMNGGBcEvi5VP9M+PGHwbmyQGOYOhFnd9x5pofbF7PI2x17cI2a9rv+FEFDm+LmV0hJcBHawiLBrfMEp43JjaUlAVWkP+SEBgnBm/3usYKb5sYfo5d2Kr77KklAiv1N2iEcl84SfHeehxNHuS6EcW3girPDNV8DeeKSQ7f3tNFiVEBmk3vz09JOjeZKOpnHSfRgKYDlRSFLrQitMecxUUN94xQPnz8+zsJfvhdYsc8F257YpIGLrLhtnljwrjtbK5ugbBRCUJVLJeoauL4k+HztFA83v+Lbi2xXSZF5/xTBV+Y4w/A9E90ywUlq6fIpxZ6Y1ue6T2bYr9cCK3arZYyTDXRSQDix1Ba/WQOr82VklTYTx1EZuqPqisIpjBTQI6phyb1Zw0h9BEaXC+5boXhqc+DxqOAbpxbYEshrTp9N0scQVOVU90+6fKwn+cd2urouf0JX8tWd6KiUI9/iyyeKPaHMdHb2DOL/FAQEYQrIwv3AD1f40KbuagmTA9tPUYtweRhR5ll0lXZIyEaO+XHfiILLQOD7jxCzr+5Y7Cr9DMynT/Dsem98WW1pnTvWxWdyqd1mIY1tlo1EjmQYNEgXbFLc+JJvXkqEZOw79/Wvmx0T/JunOsO1LBBxPpDG9vKc68IKNw1eH1sMDC8G9jT33TWRdkgyMb8ullDcJdJ5cqlRKATfeVltqXTSoygrEktOkvBMTcIUQ1Up8LWTPHxoqiNtZ11IFLWFKqiHZldAeBNf2s6OgjHUsT2lJLDIw4KjjsIj16Lyc88A35vneKxcuz10pgMycceJY7nB3BGC+9/jGa2gPYXllEQjxlKW7Gb3ZeDY4U4jHBmEwhsT3PBiL17zxfeRqX79S2ourQlHkWBIEXCgUeM1EHDCxVLOr76gtmQx/lOWZf1O2eAQaiNHMgwGvWgAuoIntZvPNlFMvn3vtTDEINbAhXkaLhuba31c+bTg5nd7lhGmW2sCElikzMkERW8WV6Dhy9gDYw6Mq7AFZnkvJ4BCxWAXa3BYB0xSU0hZpBA0hE1kPEVRkBvgNXE5+SoDeY1uXEWFwAcmA3/YwKhpgQ3uyuMERw52HFTGfLis3r88hnePLbQEYZZRS8M+hU4ZfQvyKHhzQqV642me5WbI8xRRfMcMVcWgIpYFeLhhkY+aFrHJ/s+FPr56kmcGoz1xwbrSGItnVRmwYgvLDTXAwh2KtXscEZkT0NtrD8/b1aDmpTBSyxQBtZRL8VOHNaPYK8KuRg8Lt6iNM+xkxEAgPbNXdvnOMCooxIenKr50gmcCzAzzRx9zScqle2LYWldg5Q7ZXGYoGzmhQVqDivhgUPZ0h7zO6gTXjxPDHMqESg/fCNU26wRf87Gx1lXJhXe0uc1FXWnUMkD2zX8wP6IA20Ps55LhmxGZ7MOhwVI2e7jgupMF04cK6ltdO0j4RdjZ4OH7r/v43Zr4WJhP+v58D7NHCJbsoeopsl5ng0sdB5bj4DJJzbSjwUe7V2zaLgdQW0htnO1xDCkVTKoWHNzN0kPFL1eqCQiXnJ++Gbc9pg32LAcyb5zg7rOA773qCqI4a3HyjkNr0DuEQsKyzuWBMIHBqSABmGpvDi5RL+9SrD4gmDLYka1dmt4zd7wjjA9YeScjpCzioiDMGAxHhhUPD64GTh6lpsn+9JZatNWW2EEul5RtI5WywSVma7aXGE4662XfYD0LxBJprIV16tndpqFlYpVvJUGNK2/8zXNJ/vFx9xJNqFxwMQa+l9qDF0hv5/RxrpSyiRyOoOFLKoRgDXqE0P1mLQ+/zrSfBI1rYsFqI4pPz/Jw+TGO18E4h2/MedbmeFh3wL3vs39rN4+mKRYmdDxrczWmIvuOLmWjUD2sQZbVGZ9kX+OTy5HFuxAqCj3BV08Sq9AP8xRFnuNsfiEIRF33gu+YaMH7qTWY5xhWyrA6NU6B9Td9dS+wcjdwwWTW0UaG0iM4TArd4BIX/3h1p+KFxEesFKj2gJveXYBzJzp3NeS00KhlMu8rczxc/azv2mWJZwG4jsVO3JKbC33PKBvCjQl9X/8WOZohUDhoI3zycT/gkzo1K1B4HksdBV86wZVOht5DV4T7v3z9JcWy3XFtQm1zzRwP/zLVNZahUNElpfDR60l1kyC+n9lZarlbX/Wdm2uqhck24Lsni1XHdaeheBqN65fJtF+iJmCtIfMgsNM5zofe51mENZuJO8+TcyRbTWNCsKr91tdcSpxg0o1rNpcdCgPdSmvR0MNkctIY3bzksZiJVyLYQoFCxkk7lJD1Bhq4r/S42Np70Xbt2HjIUADcd45nlIWekm70VkhVIAGa2oLLjdUUb3Oa9IPTBN+d61kkNltgM5lCdpM52KT1ZDFnehy+urQ3+2IYVHDNSYJzJyWf1aS2oFvI9lBW8BxGq1SNTfapnWoxh49OF6uzTTYI1RxQGx9ZD9y5xGdvUdMY5OWZlSoeKguc69ybsZfaeNFRud8e2Esv7vDRHgP+uJ6sdsXZZVnaekSknrLhvlqxNnJCBkDV/MzWeKsoburz7jRS3nwfW0GZcPg+Zg9HR5kkg12sxL/sCcXDa11zvN50W6ahSxIyychXPKW47XW1MD7XRobvzx/vufBpuxinw2V2kweXkuNHCP7tqDiBm9TF/X2YHkgKgUyYgIhgdTbGsKfR5V9CXDJD0lKptClsbxd1dghjJved5+HD06SDC0A+yFXP+fjck77ZEGzW0l3BNZ9otohiueb/ejZmhVIr9oVUA8UHZwh+fo7gfWyJGRNbXoYlEZ3tDiwYo/YMtR8pAa6jUeYRyoSjughegOJfMz0KRjdX7nP590HFzGSm192Py8aksNJNXaXb7BGuDfc5kwT3vKHWqpt2A8sxF/1Fcd50wb/NchV0jGhybvjU8rzfrFH8fm3iBDEsDnz+eM8+j/aMkZR8d4weS3EahB/aRtMGs1ujbx0eWedLBt0poyOn9jtMJkIB8QQLu3mI+h3MUYT9OJjuHp2m708NwpaSlvn1gG0xt7SwlyozpBQCtq782XIfW+roLqgF2vjD5BiLq6jq/xr0C0tM7PHpvvJYwQemOEOafc3YC3UzExWW0lWLXaTaPTEEe7+SkRb2bMvWEkOZQCggVSWyuqZRt2e6R0him0qWEaS79wqNOVcr66gBW5riiTRqF+Y7yCg7c4JnvU3ZdtN2vhTg/61T++kavqTAsI3VR44U00SWOU7I1q49EPY8hSXdytIUEI6TnxP6vU3tmQ+YCWQ7ZQKdOgxRYhSfjJzdj0h8QkeVSVrqGUEEhZ0FS4rUWGBbtir2NbmOAWH0m7EJknJoL0ys9PA95nFqQsGITgYTgazNpcfRVTvUtCrWBxseUmpsiUzzGiiQiU1vsmKBBNoDiQIiwNOKzApIYiedrfWKpjZBcZpahF1/WHD91gFFk3jWn/2EkQEtMeZUNrcT+/tW4K+b1JJ8h4TA6nO2Nail+0PB4lLGz2M/k+1BIffgYsWo8vRLJVs6FaBnp+MyZSH8u2OKioCFKdRMpwXbFixoIPP4hhgumyUd5Q2pgoYjCT1sg0m7YNke4F0jxTQJ+4OwQv/57Yr29nhfMgRNe0kx4Psf3+h6rPPx3dfM1g+C+5b7xjpnRPf0cW6pIuPemLKiOKJKLOmYDrhScbv4P6+PJyhHHKaysL9AWYgICPti1jTpqkw20qXqP20si7WBvS2eRVOvmSOYXJ36k8N6VnYM+ON6t4b/fAWwdLdvXYM6bdsRUBO5SRCLx+ePd+PhEvHpWU6YWC+78kC8URjJSvz5wWJXxP12fcB881zRVnGQkEtFi9DVJuPtFyt9LN7jPDtGk48cHDm1X8FGumGPVHRtxa3AAwBuydRg2NWH7Rh404nfr1PsbvLx2WNdARGf5oqgS3HXex4LeKfNwQ8NRrZ+2FrnYhehTVHfpnhhW2fzgus862kunsZOQq45f2LehIk4TsxZ48XI0w+tcWWeYQKNy8CinQlUSHXCQ1YY623I/+BncOzdNb8LQWFisJCGMpc9djP681t+x9g/c6xnQptJBDLQgaw38ydB+UdvKO5aGuvUUI4ew+yRwLHDHP+TcZICie+/QpLO1gZgc40LdrEVN13OxtZQOySYd8b9FEyoorsLnD3R0fyGl/esqcgrYUCPhuzru2EdCFgE3jnbqnFrssDDuHJY0m7WUOd2U2DKAkGRhGsg32XFfpdDYrIxse6Brci5WxbbkWeyBUTXZv6Rrz7YpM9ANWNdD6kJqFpZeXbbayFFTzuyui5s3oXA3LWApNP/4R9+x2fMHOrh2jnOy2CsItFV7S00IArxaWcveAbd/roprkHCyvw4Ev7X8FrC1puH2MHCPsvDp2e59hEs0zyU9ukXiCwcXCbvSfzoSGDYAx7wM9iWm1qB2Vp27Tl+uGdtqLiLU11bUDHva3QrjcguIO6OF9r2pW7r0021XtCSwfFGWIU/Og2DT4IYBbVZZTG1Wrz9FAuk5k+AtcHklqx7zQtJyN8njN+P258J1yK2IwWzzVxyzwia6mU61e91WV7Qza22LclqmrEzG7tOUZ3vD5rxs78GN0amVU+3jwYmDbmCgC9Bu4R8VeZe2OeD1D8KAl1NBtwsg/uk4xwOrxA8/D5HHOoLdc3C8ksX+Fh9wGm4u84UvO8IMeIP7QhCoHgAAAazSURBVCB6QCv2uZ5j1I77goBdS7DjVFHQzJd2z6gK53UxnE57g5HUVHkqaUGksboUo0WkU/PvyFB4Qk2TPqzApzM9RtoDTNax++FxI2BJtuaA4NMSc12RRZwbzKeLN9qKqYPtQhK38yLNb9pgxfr9sAYypDMyWlucpoDQfmCd7up9MWOmVxar2RrDgg0T6f7OGsaOAjSeA+pjsD9dux/v3FzkxQXdSjYKkZZ7ny4EeLircKA7AYExiXBrLJZ5AQkhQere0v4lXY/0DhS08yYA6/dLh5dBZtnQ0vTGRi3x0pZgLJ7i5JGI7H8X7kmX7cKnZMA57+70ble5yhJZCcgjkQN5BKpvBrZs/RdGTn1butIJXWuQYPz7WreTFQ0KC66lKXTZhzzi5jyKbgWEKCrMXDykP0Bbg6WRtEuIXU2eBeRa2lP/MpKJuV3Ym8FOixUFZNf3jkGWyzjcXB9SQCqKZbGIPBE5kEeYMAj4xAzP2GWMizCQtT2NKiA2yn10o2Oih1unTc7wZj99Dc4x5/pQH3tIAYHzHm+KvJhHYCST242FNMAlu338Y3tyPVhD0MBk8dWCDbEgxKLGMUnXpsk2eprjwwpIVbm8KCJPRQ7kEbjM/OtR4WWKVeptSaHYlK72I+vZRqrAiMpM2tE9zZV+YqmAc8s5Ptxbe7w88XCViLRFDuQJGBMhWyyMLSzb61u2Npn99ulqc8fLB9fEo7n/frRnwax8BeeUc9vT8HsUEDKLRHBb5ECegC4neRxs1OsguG2xb1zS7sjKXcHAFhvAsEda6AJdONm1oEqXXphNcE5D1tjh0CsFWVmCmyCyOXIgT0Atwo0Cpw52QsJEHwufNtUevoBbg2Tiz5ar24cGanmczx3nHbYDdM5DZLPNaS/QKwERkUbPwxcjB/IEdHmnDxZ87eR4vwf27/jxMt9C+d3VwfrBBgG/Xq14YFX8hK+f6to4ZKWYqY/AueSc9ubTen2ZVSXyJ4E8GjmQJ6ANcvo41+7bIMC9yxXfWuRbnSypiGEROe0TEozYAPeWV+JtEVmVd8Gk3GtXmQw4h5zL3r4lKSeefJG2Fryh0Kw3vUsFnHwuK7cv9vHrVfG1hVFXstZZw0uvhH3Wu8ZMWIR1w6luU8N89VwEsq+oBMcn8j16fk+SqGnWC9TXx/vxOvoVXE5Yu0uO6Q+X+nGS0qEggo8dCdt5gi5zNkjEfQXx5MLqUlmQzMcd7tYcErXNeovv61cPdTzXwaVkd6Njtd+9lFuw+50IzOGdGVchVvDNHbdJsM5vu0O+U1Uq10UO9ICUBERVC2qb8ayqzo0czBNosN8ME3gsc6SxGrazpL3CDs4zh7jq+2jD3vyCiLxYVYr5IpJ0DDnly853e+SfBanYHYlIWWnyC8XDJfkcZX2nI4iWXpKqcCDdzuVVpfI0FJdFDgwgN6C4zOYoDaRtdlWXy2/Fk7wNor1TwTnh3KR7eX1il1eXyl20kiMHBpAVcC44J33x3X1qmx9s0p9B9fLIgQFkDiL3Di6TK/rq+/rUs68uxZUcYOTAADIDkXttDvoQfSog9LMpvQPLTebBe857n0qs43Dot/BPTbNepb7eGTkwgD6HGaR9ZHN0Rb/GB2sa9eMQ/FJVu+k5PIB0YTEoxWV94a0cCv0eQGarb/Xx0EDEtW/BCCmDYOnGOXpCRjIMFpZvxUP5nLvJJTC3UlScXoS0t8hIfpIXwmTRgPGaPlxWFvMzIRzIlAZJBPkk8PHAwJKTHLikwMOlyfI50kXGGQ68QGYX85m+mGnwXvGeZVo4kA0NkojaFr3I93EnVCdFDg7A2OckGCfDIe1rZH/vXtXyuhZcr4qrB9xhB0vTC25jaUJv2ef9NpbIK1lCbYvOVB93qeq5uTKmbIDlkKx4601RUyaQc0S62kadq0KNoudHDr6DwSp7FlL3VCubaeQs07KhVU9sa8d1gF4cOfiOgjzC/hyHa8GQTeQ8FbeuRWf5Pq5R4KPZaKzXLxBpZE8wtn06VGefnBlq5JUcBbsv1jXjIz5waSb7uPYpRBay1WRlKX7fXcO4nBxy5JU8gHWEbsVlAlyayd7yqYC9z9neurgYv8xU9LNPxx95Jc/Q1KST24CzFDgbyt+Z3RSpK7gZD/db4ZYa3DUhsTF+PiLvBaQr6C77irNEMU8VMyGY3m9bvorUc3dIbgDIPd64jVeuuKd9hXecgHQHLkntbZjpA9PFxwwFxouginXbClB4qkQxCO41lgvUqqCe8iaw3/Wq9vdWblfuAWsLi7A6H5eMpADg/wO7paCxwHkrYAAAAABJRU5ErkJggg=="

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/storageEquipment1Bg.c1e1753.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/storageEquipment1.84db5ae.png";

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAACQCAMAAACvSQB7AAABLFBMVEUAAAD////+/v////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9fkfL///+vyPjR3/tgkvKxyvj7/P7U4vuAqPRklPL5+/73+f7x9v2fvfd5o/Rtm/NpmPP0+P7g6fyqxPiiv/d0n/NwnfNnl/KmwveWt/aStPbK2vqaufaFq/Xu8/25z/nq8f3k7PzF1/q1zPmtx/iIrvXa5vzX4/u80fmOsfXn7/3A0/m3zfnC1fpy/0yaAAAANnRSTlMAgP77ewcLHQL3hyLdEePWvGAB8+fJNC0XBFhT7NHFsaSgmmwo8MzAqXI7i3VLSLZmXEOWgq0KAQyvAAAGRUlEQVR42uzYa1MSURzH8eMiV7mYaVGmpKGFipcu/6/c5SKoXEQsU0zLev/vIcdmpAar3a3Zs8z4ecqTH2fgfHdW/QP/bGgyNh0MTscmV59OKNfyp2b4xfKaX7nRxKKHIZ7nSeU28R9D84Vct7ZbKu3WutuZHQDjubtO1ptaArjo1eUn7cMMwMMxn3KNdBigcCxDihmA6FPlDskNgI/ncqfjPYCXj5V+kVUP0DjIyu9UK4CxGFd6BTafAcZlXf6g/TUPLKWeKI1W5gAuavIXzQxAbF3p4n8FcNIVEz5/AdhIKh18Y0Gg3C+JKdlOA/Csari4nkYB47Qlpu1eGcD0g4By1KN5gL2iWFK8AFheUc6JLxrA+55YdngC4FhrvWtLQP6sLTaUtneAh+M+ZZH9imaaYlPrCCA8qyyyX1FTNLZ2UFH7Bq19E1FDnKzogIbWmqioDbWh1uqo6DXzrU1MqGv6KmqltcFBazVU1HJrpzRU1LLip0FrNVRUU2ufWK2o/dZ61T95PGe1ovZbG3uk7JsaD1qvqP3WekIBZZP3OVDuZMUJ1TKQ8ClbfJPAp6Y4pFUAZiK2/lCTwKU4KAfM2DnXBTD2xVFVAxIBZVUK2BeHVYGQsigZhCtxXA48Fu+swDzsZcV5BYhZa8EW7NREg1YZUpYONQx90eIApr3WDrXRFi2y7+GFMm8e+qLJAcwp0/yQr4smpTIkrdypGdHmCMaUWRvQE226MK/MegZN0WYXHgbM/1QbotEJPFbmrENBNMrArPlb9VQ0uoJNZc4L+CAancGaMmcctkWjPrxV5oxpnroPofup91Pvp/5XHVgdkak9WBiRqeewPCJT23mIq2HJ9a0Hrye8bpoqhTserlcWotwIvkoH3DO1C0vxoXf8A9G0a6bKR3j5RN2aeusBqGROvxVOAFiIuGXqcR42fL+85925KsqNWq4CzEVcMlU6QDg9pa4FHkSBQlNu1b8BMz6XTJU+QHhxPJSIMvye99CAhFumSq/BrXJ16FMD0m6ZKvUPFW40zloy5BLCXrdMFcmeV3O5g2L2zi9SgS33TP2jDrwbkaktCPpGY6rswcqITD2C2RGZegmbIzL1ezt3upRGEIVhuGUAF8Q1gOC+k8QYS2O/oqCIwQ1xN2qiMdH7v4d0UprBokwNMEP3pHz+8ucUNfCdPjNzrmHOJ6X66AK4hIQ/Si1mwSd/Vnswa04ErJ69HKwbXyBlSqnl6/OndqUoq1zAkCntynGBv3ZOqz4NQK8hTeB+AOhSrfXHLqgaTZ9mIW1Ia70FdA222QeW3bPKThbojJpR6noeZqPiUTiNknn8fX3+ugPMDBhyDNyFWKjicN1ioezkrq4eD9ejYUMO18fQ3yoqJWapMDxvzMgiR/V9i/hEJ39Mp1PmDILKWQIDolpkMdU7P5U0abx2ByM+GVpuwYRPSvXRLbY1CL6W+lrqf1Zq0D+l6n504TtM+uSBkCtICWc+QEZqlIN54UwEClKjAkSEM33TcCC1OYAh4VQPHEltjqBHOBWEE6lNBuaEUxHIl6Um21mICMdm4FBqsgcx4dwCnG9ILTYK0CucC3Vp+1r3oDMpajAJmyWpQSkPC6IWyWG4lRrcwExS1CRuwb1sugtoT4gatQD7sskOgaCoVdsyBJpc634A0n2iZqER4Fo20T0wGxJ1iI4AtyXZJKVb7EllrcLLwGZzLoLV/U0gHRJ1avtk2QNjT327BKyWPlG/eDfKicfda+kEZTguGhIK9gP5FQ87go01V15kVlrHUM4967WPzlHGBoQb3sVQbjx86T4WFy7p630DBH4WpcuKDy6vMlDCHe3uv3+9urcJtHeEhbsioyg/7qRi9NqN3xa7UTJuLTPJoQwvCk8kJ4eA7P22G0/RZYGhyTbhleiSBRS2Gr1ItwqAtRQVXkr0YGdtIylKT0J4bbCzsawteb8kqjprdaWo91lrp+i4wxTVkLX1pajLWftQ1JCi9WetVymqI2vtFF2OCD3srHWWot2LQh87azWkqPtZa6eofnbW/iNFTVjAa2dtZv2ltcYqRY2hshYld1SWFcqnOR5T1CSt4xZKPrPytIJ7LZNHsVSKmmZKFVvFGjdzZ3zr3AzPxN6atdT8mUjq/dMS/o6U93X+ApCo6z1ntpG9AAAAAElFTkSuQmCC"

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home-about.4784754.png";

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14928ee9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14928ee9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Store_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14928ee9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Store_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store"},[_c('header',[_c('div',{staticClass:"banner"},[_c('h3',[_vm._v("高性能融合型存储")]),_vm._v(" "),_c('h4',[_vm._v("CompubiqStor")]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"circle pa"},[_c('img',{attrs:{"src":__webpack_require__(95)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-equip","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"equip pa"},[_c('img',{attrs:{"src":__webpack_require__(203)}})])])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('section',[_c('img',{attrs:{"src":__webpack_require__(204)}}),_vm._v(" "),_c('h4',[_vm._v("国产自主可控")]),_vm._v(" "),_c('p',[_vm._v("采用华为TaiShan服务器作为存储自身硬件，"),_c('br'),_vm._v("信易达自主研发存储专用操作系统，"),_c('br'),_vm._v("内核经过高度精简，充分保障软件系统的"),_c('br'),_vm._v("稳定、安全、可靠")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(96)}}),_vm._v(" "),_c('h4',[_vm._v("融合型存储")]),_vm._v(" "),_c('p',[_vm._v("多协议融合型存储；"),_c('br'),_vm._v("SAN支持iSER、SRP、FC、iSCSI"),_c('br'),_vm._v("NAS支持NFS、NFSoRDMA、Samba"),_c('br'),_vm._v("并行支持Lustre、BeeGFS")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(205)}}),_vm._v(" "),_c('h4',[_vm._v("极致性能")]),_vm._v(" "),_c('p',[_vm._v("控制器最大支持48核处理器、2TB内存、"),_c('br'),_vm._v("支持业内最高水平接口类型，"),_c('br'),_vm._v("32Gbps FC / 100Gbps Ethernet / "),_c('br'),_vm._v("200Gbps Infiniband")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('h3',[_vm._v("技术规格")]),_vm._v(" "),_c('table',{attrs:{"border":"1","cellspacing":"0"}},[_c('col',{attrs:{"width":"140px"}}),_vm._v(" "),_c('col',{attrs:{"width":"300px"}}),_vm._v(" "),_c('col',{attrs:{"width":"300px"}}),_vm._v(" "),_c('col',{attrs:{"width":"300px"}}),_vm._v(" "),_c('tr',{staticClass:"header",attrs:{"height":"100px"}},[_c('td',[_vm._v("型号")]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"width":"60%","height":"auto","display":"block","margin":"auto","padding-top":"120px","margin-bottom":"5px"},attrs:{"src":__webpack_require__(206),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("U3100")])]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"width":"60%","height":"auto","display":"block","margin":"auto","padding-top":"60px"},attrs:{"src":__webpack_require__(207),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("U3200")])]),_vm._v(" "),_c('td',[_c('img',{staticStyle:{"width":"60%","height":"auto","display":"block","margin":"auto","padding-top":"20px"},attrs:{"src":__webpack_require__(208),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("U5000")])])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("控制器数量")]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("2")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("处理器")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("鲲鹏920（24核 2.6GHz）")]),_vm._v(" "),_c('td',[_vm._v("鲲鹏920（48核 2.6GHz）")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("缓存")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("32G-1T/每控制器")]),_vm._v(" "),_c('td',[_vm._v("128G-2T/每控制器")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("Raid级别")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("0、1、5、6、10、50、60")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("支持存储协议")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("SRP、FC、iSER、iSCSI、NFS、NFSoRDMA、Samba")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("接口类型")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("8/16/32Gbps FC 1/10/100Gbps Ethernet 56/100/200Gbps Infiniband")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("磁盘类型")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("NVMe SSD、SSD、SAS、SATA（支持混插）")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("双控最大磁盘数")]),_vm._v(" "),_c('td',[_vm._v("1908")]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v("3816")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("扩展接口")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("12Gb/s Mini SAS 3.0")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("扩展柜支持")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"}},[_vm._v("2U12/2U24/5U84/4U106 2.5/3.5英寸盘位")])]),_vm._v(" "),_c('tr',{attrs:{"height":"37px"}},[_c('td',{staticClass:"header"},[_vm._v("高级功能")]),_vm._v(" "),_c('td',{staticClass:"table-last-wrapper",attrs:{"colspan":"3"}},[_c('div',{staticClass:"table-last"},[_c('span',[_vm._v("·重复数据删除")]),_vm._v(" "),_c('span',[_vm._v("·虚拟磁带")]),_vm._v(" "),_c('span',[_vm._v("·压缩")]),_vm._v(" "),_c('span',[_vm._v("·精简置备")])]),_vm._v(" "),_c('div',{staticClass:"table-last"},[_c('span',[_vm._v("·快照")]),_vm._v(" "),_c('span',[_vm._v("·ALUA")]),_vm._v(" "),_c('span',[_vm._v("·克隆")]),_vm._v(" "),_c('span',[_vm._v("·远程复制")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cert-wrapper"},[_c('h3',[_vm._v("技术认证")]),_vm._v(" "),_c('div',{staticClass:"cert"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(209)}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(210)}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(211)}})]),_vm._v(" "),_c('div',[_c('img',{staticStyle:{"width":"auto","height":"60%","margin-top":"50px"},attrs:{"src":__webpack_require__(212)}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caser-warpper"},[_c('div',{staticClass:"caser"},[_c('h2',[_vm._v("客户案例")]),_vm._v(" "),_c('div',{staticClass:"case"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(92)}})]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(89)}})]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(88)}})]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(91)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cont"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("地址：南京市江北新区腾飞大厦A座4楼")]),_vm._v(" "),_c('p',[_vm._v("电话：025-68155007")])]),_vm._v(" "),_c('div',{staticClass:"qr"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"spa"},[_vm._v("关注我们")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('p',[_vm._v("版权所有 © 南京信易达计算技术有限公司 "),_c('a',{staticStyle:{"color":"rgba(255,255,255, .4)"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("苏ICP备2021021510号-1")]),_vm._v(" 苏公网安备 0000000000号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/store-banner-equip.e619ea7.png";

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list2.88bf8ad.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/list3.dc6a063.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert1.ee1a9a9.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert2.85258fa.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert3.c8b880a.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert4.636adf4.png";

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Software_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3fb48c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Software_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3fb48c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Software_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3fb48c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Software_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store"},[_c('header',[_c('div',{staticClass:"banner"},[_c('h3',[_vm._v("高性能运维监控软件")]),_vm._v(" "),_c('h4',[_vm._v("ClusterMom")]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"circle pa"},[_c('img',{attrs:{"src":__webpack_require__(95)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInDown banner-equip","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"equip pa"},[_c('img',{attrs:{"src":__webpack_require__(305)}})])])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"cert-wrapper"},[_c('h3',[_vm._v("界面展示")]),_vm._v(" "),_c('div',{staticClass:"cert"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',{staticClass:"scroll-content"},[_c('img',{attrs:{"src":__webpack_require__(306)}})]),_vm._v(" "),_c('swiper-slide',{staticClass:"scroll-content"},[_c('img',{attrs:{"src":__webpack_require__(307)}})]),_vm._v(" "),_c('swiper-slide',{staticClass:"scroll-content"},[_c('img',{attrs:{"src":__webpack_require__(308)}})]),_vm._v(" "),_c('swiper-slide',{staticClass:"scroll-content"},[_c('img',{attrs:{"src":__webpack_require__(309)}})])],1),_vm._v(" "),_c('span',{staticClass:"arrow",on:{"click":function () { return _vm.$refs.mySwiper.swiperInstance.slidePrev(); }}}),_vm._v(" "),_c('span',{staticClass:"arrow arrow-right",on:{"click":function () { return _vm.$refs.mySwiper.swiperInstance.slideNext(); }}})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"center pa"},[_c('img',{attrs:{"src":__webpack_require__(310),"alt":""}}),_vm._v(" "),_c('h3',[_vm._v("Cluster"),_c('br'),_vm._v("Mom")])]),_vm._v(" "),_c('div',{staticClass:"item item1 pa"},[_c('img',{attrs:{"src":__webpack_require__(96)}}),_vm._v(" "),_c('h4',[_vm._v("异构融合")]),_vm._v(" "),_c('p',[_vm._v("平台可搭建在X86/ARM服务器上，支持X86、ARM混合集群，"),_c('br'),_vm._v("不限品牌与型号，拒绝捆绑")])]),_vm._v(" "),_c('div',{staticClass:"item item2 pa"},[_c('img',{attrs:{"src":__webpack_require__(87)}}),_vm._v(" "),_c('h4',[_vm._v("作业管理")]),_vm._v(" "),_c('p',[_vm._v("支持LSF、Slurm主流作业调度系统。实时队列、节点、用户、作业监控 提交作业 历史作业查询")])]),_vm._v(" "),_c('div',{staticClass:"item item3 pa"},[_c('img',{attrs:{"src":__webpack_require__(85)}}),_vm._v(" "),_c('h4',[_vm._v("告警预报")]),_vm._v(" "),_c('p',[_vm._v("机器硬件设备告警  资源阈值告警"),_c('br'),_vm._v("作业异常告警 告警转发邮件/钉钉/微信")])]),_vm._v(" "),_c('div',{staticClass:"item item4 pa"},[_c('img',{attrs:{"src":__webpack_require__(84)}}),_vm._v(" "),_c('h4',[_vm._v("计费统计")]),_vm._v(" "),_c('p',[_vm._v("实时作业计费（后计费）"),_c('br'),_vm._v("计费统计周/月/年报 自定义计费规则")])]),_vm._v(" "),_c('div',{staticClass:"item item5 pa"},[_c('img',{attrs:{"src":__webpack_require__(86)}}),_vm._v(" "),_c('h4',[_vm._v("资源监控")]),_vm._v(" "),_c('p',[_vm._v("CPU、内存、网络、磁盘IO资源监控"),_c('br'),_vm._v("资源管理/监控大屏")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caser-warpper"},[_c('div',{staticClass:"caser"},[_c('h2',[_vm._v("客户案例")]),_vm._v(" "),_c('div',{staticClass:"case"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{staticStyle:{"width":"460px"},attrs:{"src":__webpack_require__(90)}})]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__(93)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cont"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("地址：南京市江北新区腾飞大厦A座4楼")]),_vm._v(" "),_c('p',[_vm._v("电话：025-68155007")])]),_vm._v(" "),_c('div',{staticClass:"qr"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"spa"},[_vm._v("关注我们")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('p',[_vm._v("版权所有 © 南京信易达计算技术有限公司 "),_c('a',{staticStyle:{"color":"rgba(255,255,255, .4)"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("苏ICP备2021021510号-1")]),_vm._v(" 苏公网安备 0000000000号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-banner-computer.4d85bb6.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/software-monitor1.e2e0f9c.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/software-monitor2.173e996.png";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/software-monitor3.e4c7c64.png";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/software-monitor4.c8d857c.png";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/software-circle.54b6d23.png";

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44adb86b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44adb86b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44adb86b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('header',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"banner-office"},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInLeft","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"office"},[_c('img',{attrs:{"src":__webpack_require__(314)}})])]),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"animate__animated animate__bounceInRight banner-info","leave-active-class":"animate__animated animate__fadeOut"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"info"},[_c('h4',[_vm._v("公司简介")]),_vm._v(" "),_c('p',[_vm._v("南京信易达计算技术有限公司成立于2018 年10月4日，注册在中国(江苏)自由贸易试验区。信易达是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技 企业，拥有超算中心建设、部署、运营的 自主可控一体化解决方案，产品和服务覆 盖政府、军工、高校、金融、医疗及科研等行业。")])])])],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('h3',[_vm._v("关于我们")]),_vm._v(" "),_c('h4',[_vm._v("信易达成立于2018年10月，是一家致力于国产自主可控软硬件产品研发、生产、销售的高科技企业")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('section',[_c('img',{attrs:{"src":__webpack_require__(315)}}),_vm._v(" "),_c('h4',[_vm._v("高性能存储"),_c('br'),_vm._v("CompubiqStor")]),_vm._v(" "),_c('p',[_vm._v("\n        — 国产自主可控"),_c('br'),_vm._v("\n        — 全定制专用存储系统"),_c('br'),_vm._v("\n        — SAN、NAS融合型存储"),_c('br'),_vm._v("\n        — 高可靠、高可用、高性能")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(316)}}),_vm._v(" "),_c('h4',[_vm._v("超算运维管理软件"),_c('br'),_vm._v("ClusterMom")]),_vm._v(" "),_c('p',[_vm._v("\n        — 资源监控"),_c('br'),_vm._v("\n        — 作业管理"),_c('br'),_vm._v("\n        — 计费统计"),_c('br'),_vm._v("\n        — 告警预警\n      ")])]),_vm._v(" "),_c('section',[_c('img',{attrs:{"src":__webpack_require__(317)}}),_vm._v(" "),_c('h4',[_vm._v("高性能应用容器"),_c('br'),_vm._v("CompubiqContainer")]),_vm._v(" "),_c('p',[_vm._v("\n        — 打包应用程序，开箱即用"),_c('br'),_vm._v("\n        — 去繁就简、解决最后一公里问题"),_c('br'),_vm._v("\n        — 原支持MPI与GPU"),_c('br'),_vm._v("\n        — 平台间可无缝迁移")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cert-wrapper"},[_c('div',{staticClass:"cert-cont"},[_c('h3',[_vm._v("公司资质")]),_vm._v(" "),_c('p',[_vm._v("公司非常重视科技创新，不断加大研发投入，取得了显著成果，已获得科技中小、国家高新技术企业认定等政府荣誉资质。截止2020年底，"),_c('br'),_vm._v("公司已获得专利证书6项、软件著作权证书12项、商标证书10项，并已获得ISO9001质量管理体系认证证书。")]),_vm._v(" "),_c('div',{staticClass:"cert"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(318)}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(319)}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(320)}})]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(321)}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cont"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("地址：南京市江北新区腾飞大厦A座4楼")]),_vm._v(" "),_c('p',[_vm._v("电话：025-68155007")])]),_vm._v(" "),_c('div',{staticClass:"qr"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"spa"},[_vm._v("关注我们")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('p',[_vm._v("版权所有 © 南京信易达计算技术有限公司 "),_c('a',{staticStyle:{"color":"rgba(255,255,255, .4)"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("苏ICP备2021021510号-1")]),_vm._v(" 苏公网安备 0000000000号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about-office.78701c0.png";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAulBMVEUAAAAAjfwAjf0Ak/8AjfwAjfsAjPsAjPwAjfwAjfwAjfsAjf0Aj/wAkv8Al/8AjPv///+33v30+v5SsfwKkPu23v13wvz6/P7o9P4uofuMy/0jnPsemfsGj/vu9/7Z7f694f2X0P1ou/xctvwRlPsMkfuw2/3j8v7d8P6a0f2GyP1Fq/zO6f6v2v2m1v19xPw/qPwzo/vT6/7E5P6h1f1ht/zJ5/6q2f04pfuCx/1xv/wXlvtLrvyz3f0KHA8FAAAAD3RSTlMA838L6NnTv6qlgnJSIxZHPVeXAAADL0lEQVRo3uzVV27CQBCA4TU11Bm8BleKC5hmsEEEhMj9rxU/IBQcCJ41+5bvAr80W4bd67Qa9aoCBSjVeqPVYU91mzV4k1qz+zBRLinwRkqp/LvRrsCbVdrZRgkkKN2P6gOk+Pg5MkKDWKHMqvjE2iBR+3ogFZCoUiYOS3xgXQWkUrpppAmSNdNIDSSrMdYB6TqsBdK1WAOka7A6SFdnVZCuyhSQTmGQi2bywaK3X4/Dka6PwvF631sMuKlBLq8jw3jbN/AJo7+Nh0Ujmj9T8QV15msFIo6rYi6q6whGNEvH3HRLE4k4YyQZO/TIdI5E8yk5MkCyATkSIVlEjvSQrPcfkRtxkcwlRxIkS8gROCPRWeTv4gYSGFzsFw6WKuakLgPhfRJ4n5jD2guKbUbHi4w/xzTzHOHNaMVwY6cLfhJiRjhJ17wNN7El8Bg3ZmbZ2+ZpxX3P8/kqTuzMajc32Bd68ROuQS4anyCKRVLq8WDDC/bhqCKKRq7CaHk4BfBAcDosoxBTgpF+9hbtN661PXs+57533lruZp+9dV/024Vk9Ntl60ik2+QIXHRi4yLy4pMdEuwSwW/lmxl7y3EQhMIAvAWHNF5qVVqFEFCmUoQSOvvf1sRkMm2KMVxeuoL/gZzvcP6F+EaQJcEuxoEHwZwlng4NO96KnZe4HVkTDaRcXoKqPyEdH6uXgEVGTLxydh2yq5HsXtUWOXtURbJC8toPyPqbpNg1Uob2AxCjY5YMZCG06e/Dlo+90aJIAPLH2bMKTnI1ctVRTlCVWTKQNBxIGhxi29CM1oYP49wGZswxE29xSAa2kaxcv7yvhmuCXbURHsqbOtIu9PxCym7nepfPDyQKDsH08FYSwa4E/7qXHXyriQ4UR0x8mQ8b8g+n07Bh+5CXkawA+Wh8fGweEqTY1epLtZ9QXXSbDmQGRm762XlWNPdGjyBLAHJyR5oIBTE/nzmGShAXhOkzC5yYKuozS7XfZu2ABAAAAGFY/9ZmEGRY43ufB39DZ5Ns/+PzJqMTECC0QZCGcBOBM0KAAjMJyxJgFlRO0F/sC2LEEEsJmWPA5iOGJbFe2YmM7HABo4RiSIrbtXQAAAAASUVORK5CYII="

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAb1BMVEUAAAAAjf0AjfwAk/8AjfwAjfsAjPsAjPwAjfwAjfwAjf0Aj/wAkv8Al/8AjPv////d8P5kufwhm/tetvyi1f0Gjvux2/3N6P4DjvwRk/t/xf2w2/1Wsvwwovsqn/vt9v7T6/7J5v6k1v2My/0+p/twu4bBAAAADnRSTlMAgPML6NnTv6qlclIjFjy9diYAAAGOSURBVGje7drLjoJAEIXh7uYmt4JBURR0ru//jBNDwomjs2itqrDof+fqi7ghnjK3VUWeJY5eyCVZXlTm32qbElOprR8SkXXEmLPRvVHGxFxc/jXsQOwN9vZRbUikTWQQDG4FhiWx7PKbDyTWUM5GFJNgcYSHJZe9GrUj0Vwt+0XwVVISLjWmIvEqU5B4hclJvNxkJF5mEhIvMY7Ec4YUCkhAlgLij3TbN8+m3hc5vjfeffoiU/NEnSeyDUhAVoCM51YcGXvqWikEBtFFFtlfDdoJIjDkEBhyCAw5BAYv8vX9yOBFdkSne4MJgQEFBg8CAwoMHgQGFBhcCIz+OCsw2BAY+8OswGBDYDTNrBAMNgQGFBg8CAwoMHgQGFBg8CAwoMBgQmBAwScm5AIDcSNtR/0o/krUnscVvHcFJCCrRH6eQXpPhE4frWeHaZ1/ewQkIAFZUhkEVKYNlZFGZW5SGc5UJkCNMVNlllUZmDWmcpXRX+N8QeMQQ+OkROU4RuHMR+NgSeP0SveITOUc7hfX6xy9ieF4TwAAAABJRU5ErkJggg=="

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAArlBMVEUAAAAAjf0AjfwAjfwAjfsAjPsAjPwAjfwAjfwAjf0Aj/wAkv8Al/8Alf8A//8Ajv8AjPv///8zo/s2pPv7/f4IkPsal/vM6P71+/7W7P7j8v6Ny/0jnPsUlfvx+f674P1Krfw9p/zr9f7X7P6s2v2h1P14wvxpu/xctfxOr/wsn/sNkvuZ0f19xPwPkvvp9f7C4/603f1iuPwfmfvH5f6GyP17w/xSsfzZ7v5tvfxvPK+FAAAAEHRSTlMAgPPo2dO/qqVyUiMWDAEJqkRvOQAAAjxJREFUaN7s09lygkAQheEBl7h7RgFRwB33uC/J+79YUo0lKkpSMn3nd6VlFb8z3YhbxXwum9aRgJ7O5vJF8VRJy0CRjFYSj5Q1HQrpWllEFFJQLFUQtyoaGGgVcaX6ARYf1atzsDSoEp5FAxvtMnMwKghSToFRqsx8WeGFlXSw0ku8BwmPkgGzjBBFsCuKPNjlRQ7sciILdlmRBru00MFOFwC/d+Qd+Z/5dDrHFYaI+WlLaR9NnHFEJi1JWhMQhkivIS8aPYAh4g4laTYlGbrKI0vHoEf7O2Dn00fDWaqNjPv03HUNpL6nr/2xwkg3uKGvU2QFml1FkVkn+NvfZmSZf3VmCiLewggG4OGOdR7NwksYMUdtetLGxQO1Nf3YHplJItbgj5fiFIxmYCWI0Nu32sYd9UijabwesejOXcTa0lmslyM1OgjiuRSpJ4tIB3G8jYIIvXGx26cgQjq1J/Og5VIQIYZvIWJKC64oQuzDHDd6eymVRshqjNCM5q02crcBO9+QLJFwAzzHlpIrQtaHIW0tZ4S8Iz/tmrEKgDAQQ3/BxYogKCoIgv//ew4OEaSlcPVBy73xlqzJJS7iIi2KhHyRYLFEmQw2c5fFFqw2NYVsqtlwx5HhtkeHBPNZLgRFGJfCce7LepQPpkLB9JeILfapq/RZwLw99MC5el1qfUU9uMgbF4mCFAJItYGUNEjdhBRnSAVIlJlILYsUzERVjpT+xHyBGGIgkxJiHEPMfIDBEjG9YkdkyBzuBgQWbCazvAVAAAAAAElFTkSuQmCC"

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert1s.0824e37.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert2s.628edf5.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert3s.da5605a.png";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cert4s.c7f05af.png";

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b05e778_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__ = __webpack_require__(370);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b05e778"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b05e778_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/template1.5986589.docx";

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setup"},[_c('div',{staticClass:"config"},[_c('div',{staticClass:"config-box"},[_c('div',{staticClass:"config-step-title"},[_c('div',{staticClass:"step-item active",on:{"click":function($event){_vm.curStep = 1}}},[_c('span',[_vm._v("1")]),_vm._v("\n            管理节点\n          ")]),_vm._v(" "),_c('div',{staticClass:"step-item",class:_vm.curStep >= 2 ? 'active' : '',on:{"click":function($event){_vm.curStep = 2}}},[_c('span',[_vm._v("2")]),_vm._v("\n            登录节点\n          ")]),_vm._v(" "),_c('div',{staticClass:"step-item",class:_vm.curStep >= 3 ? 'active' : '',on:{"click":function($event){_vm.curStep = 3}}},[_c('span',[_vm._v("3")]),_vm._v("\n            计算节点\n          ")]),_vm._v(" "),_c('div',{staticClass:"step-item",class:_vm.curStep >= 4 ? 'active' : '',on:{"click":function($event){_vm.curStep = 4}}},[_c('span',[_vm._v("4")]),_vm._v("\n            存储节点\n          ")]),_vm._v(" "),_c('div',{staticClass:"step-item",class:_vm.curStep >= 5 ? 'active' : '',on:{"click":function($event){_vm.curStep = 5}}},[_c('span',[_vm._v("5")]),_vm._v("\n            网络\n          ")]),_vm._v(" "),_c('div',{staticClass:"step-item",class:_vm.curStep == 6 ? 'active' : '',on:{"click":function($event){_vm.curStep = 6}}},[_c('span',[_vm._v("6")]),_vm._v("\n            总结\n          ")])]),_vm._v(" "),_c('div',{staticClass:"config-step-cont"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"80px"}},[_c('div',{staticClass:"step-cont",class:_vm.curStep == 1 ? 'active' : '',on:{"click":function($event){_vm.curStep = 1}}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"配置机型"}},[_c('el-select',{attrs:{"placeholder":"配置机型"},model:{value:(_vm.form.managementNode.setupMachine),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "setupMachine", $$v)},expression:"form.managementNode.setupMachine"}},_vm._l((_vm.formSelections.setupMachine),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"配置数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.managementNode.numberMachine),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "numberMachine", $$v)},expression:"form.managementNode.numberMachine"}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v("单台配置如下：")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"CPU","prop":"setupCPU"}},[_c('el-select',{attrs:{"placeholder":"请选择CPU"},model:{value:(_vm.form.managementNode.setupCPU),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "setupCPU", $$v)},expression:"form.managementNode.setupCPU"}},_vm._l((_vm.formSelections.setupCPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.form.managementNode.setupCPU.split('|')[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.managementNode.numberCPU),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "numberCPU", $$v)},expression:"form.managementNode.numberCPU"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"内存","prop":"setupMemery"}},[_c('el-select',{attrs:{"placeholder":"请选择内存"},model:{value:(_vm.form.managementNode.setupMemery),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "setupMemery", $$v)},expression:"form.managementNode.setupMemery"}},_vm._l((_vm.formSelections.setupMemery),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.managementNode.numberMemery),callback:function ($$v) {_vm.$set(_vm.form.managementNode, "numberMemery", $$v)},expression:"form.managementNode.numberMemery"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.form.managementNode.setupNetworks),function(setupNetwork,index){return _c('el-row',{key:index + 'network',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '网络' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupNetwork.type),callback:function ($$v) {_vm.$set(setupNetwork, "type", $$v)},expression:"setupNetwork.type"}},_vm._l((_vm.formSelections.setupNetwork),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.networkPlus(_vm.form.managementNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.networkMinus(_vm.form.managementNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupNetwork.number),callback:function ($$v) {_vm.$set(setupNetwork, "number", $$v)},expression:"setupNetwork.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.managementNode.setupHardDisks),function(setupHardDisk,index){return _c('el-row',{key:index + 'harddisk',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '硬盘' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupHardDisk.type),callback:function ($$v) {_vm.$set(setupHardDisk, "type", $$v)},expression:"setupHardDisk.type"}},_vm._l((_vm.formSelections.setupHardDisk),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.hardDiskPlus(_vm.form.managementNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.hardDiskMinus(_vm.form.managementNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupHardDisk.number),callback:function ($$v) {_vm.$set(setupHardDisk, "number", $$v)},expression:"setupHardDisk.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.managementNode.setupGPUs),function(setupGPU,index){return _c('el-row',{key:index + 'gpu',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? 'GPU' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择GPU"},model:{value:(setupGPU.type),callback:function ($$v) {_vm.$set(setupGPU, "type", $$v)},expression:"setupGPU.type"}},_vm._l((_vm.formSelections.setupGPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.gpuPlus(_vm.form.managementNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.gpuMinus(_vm.form.managementNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupGPU.number),callback:function ($$v) {_vm.$set(setupGPU, "number", $$v)},expression:"setupGPU.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"step-cont",class:_vm.curStep == 2 ? 'active' : '',on:{"click":function($event){_vm.curStep = 2}}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"配置机型"}},[_c('el-select',{attrs:{"placeholder":"配置机型"},model:{value:(_vm.form.loginNode.setupMachine),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "setupMachine", $$v)},expression:"form.loginNode.setupMachine"}},_vm._l((_vm.formSelections.setupMachine),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"配置数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.loginNode.numberMachine),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "numberMachine", $$v)},expression:"form.loginNode.numberMachine"}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v("单台配置如下：")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"CPU","prop":"setupCPU"}},[_c('el-select',{attrs:{"placeholder":"请选择CPU"},model:{value:(_vm.form.loginNode.setupCPU),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "setupCPU", $$v)},expression:"form.loginNode.setupCPU"}},_vm._l((_vm.formSelections.setupCPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.form.loginNode.setupCPU.split('|')[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.loginNode.numberCPU),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "numberCPU", $$v)},expression:"form.loginNode.numberCPU"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"内存","prop":"setupMemery"}},[_c('el-select',{attrs:{"placeholder":"请选择内存"},model:{value:(_vm.form.loginNode.setupMemery),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "setupMemery", $$v)},expression:"form.loginNode.setupMemery"}},_vm._l((_vm.formSelections.setupMemery),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.loginNode.numberMemery),callback:function ($$v) {_vm.$set(_vm.form.loginNode, "numberMemery", $$v)},expression:"form.loginNode.numberMemery"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.form.loginNode.setupNetworks),function(setupNetwork,index){return _c('el-row',{key:index + 'network',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '网络' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupNetwork.type),callback:function ($$v) {_vm.$set(setupNetwork, "type", $$v)},expression:"setupNetwork.type"}},_vm._l((_vm.formSelections.setupNetwork),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.networkPlus(_vm.form.loginNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.networkMinus(_vm.form.loginNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupNetwork.number),callback:function ($$v) {_vm.$set(setupNetwork, "number", $$v)},expression:"setupNetwork.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.loginNode.setupHardDisks),function(setupHardDisk,index){return _c('el-row',{key:index + 'harddisk',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '硬盘' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupHardDisk.type),callback:function ($$v) {_vm.$set(setupHardDisk, "type", $$v)},expression:"setupHardDisk.type"}},_vm._l((_vm.formSelections.setupHardDisk),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.hardDiskPlus(_vm.form.loginNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.hardDiskMinus(_vm.form.loginNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupHardDisk.number),callback:function ($$v) {_vm.$set(setupHardDisk, "number", $$v)},expression:"setupHardDisk.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.loginNode.setupGPUs),function(setupGPU,index){return _c('el-row',{key:index + 'gpu',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? 'GPU' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择GPU"},model:{value:(setupGPU.type),callback:function ($$v) {_vm.$set(setupGPU, "type", $$v)},expression:"setupGPU.type"}},_vm._l((_vm.formSelections.setupGPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.gpuPlus(_vm.form.loginNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.gpuMinus(_vm.form.loginNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupGPU.number),callback:function ($$v) {_vm.$set(setupGPU, "number", $$v)},expression:"setupGPU.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"step-cont",class:_vm.curStep == 3 ? 'active' : '',on:{"click":function($event){_vm.curStep = 3}}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"配置机型"}},[_c('el-select',{attrs:{"placeholder":"配置机型"},model:{value:(_vm.form.computeNode.setupMachine),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "setupMachine", $$v)},expression:"form.computeNode.setupMachine"}},_vm._l((_vm.formSelections.setupMachine),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"配置数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.computeNode.numberMachine),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "numberMachine", $$v)},expression:"form.computeNode.numberMachine"}})],1)],1)],1),_vm._v(" "),_c('h4',[_vm._v("单台配置如下：")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"CPU","prop":"setupCPU"}},[_c('el-select',{attrs:{"placeholder":"请选择CPU"},model:{value:(_vm.form.computeNode.setupCPU),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "setupCPU", $$v)},expression:"form.computeNode.setupCPU"}},_vm._l((_vm.formSelections.setupCPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.form.computeNode.setupCPU.split('|')[1]))]),_vm._v(" "),_c('p',[_vm._v("理论浮点运算能力: "+_vm._s(_vm.getGFlops())+"  GFlops")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.computeNode.numberCPU),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "numberCPU", $$v)},expression:"form.computeNode.numberCPU"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"内存","prop":"setupMemery"}},[_c('el-select',{attrs:{"placeholder":"请选择内存"},model:{value:(_vm.form.computeNode.setupMemery),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "setupMemery", $$v)},expression:"form.computeNode.setupMemery"}},_vm._l((_vm.formSelections.setupMemery),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.computeNode.numberMemery),callback:function ($$v) {_vm.$set(_vm.form.computeNode, "numberMemery", $$v)},expression:"form.computeNode.numberMemery"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.form.computeNode.setupNetworks),function(setupNetwork,index){return _c('el-row',{key:index + 'network',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '网络' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupNetwork.type),callback:function ($$v) {_vm.$set(setupNetwork, "type", $$v)},expression:"setupNetwork.type"}},_vm._l((_vm.formSelections.setupNetwork),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.networkPlus(_vm.form.computeNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.networkMinus(_vm.form.computeNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupNetwork.number),callback:function ($$v) {_vm.$set(setupNetwork, "number", $$v)},expression:"setupNetwork.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.computeNode.setupHardDisks),function(setupHardDisk,index){return _c('el-row',{key:index + 'harddisk',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '硬盘' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择网络"},model:{value:(setupHardDisk.type),callback:function ($$v) {_vm.$set(setupHardDisk, "type", $$v)},expression:"setupHardDisk.type"}},_vm._l((_vm.formSelections.setupHardDisk),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.hardDiskPlus(_vm.form.computeNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.hardDiskMinus(_vm.form.computeNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupHardDisk.number),callback:function ($$v) {_vm.$set(setupHardDisk, "number", $$v)},expression:"setupHardDisk.number"}})],1)],1)],1)}),_vm._v(" "),_vm._l((_vm.form.computeNode.setupGPUs),function(setupGPU,index){return _c('el-row',{key:index + 'gpu',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? 'GPU' : '',"prop":"type"}},[_c('el-select',{attrs:{"placeholder":"请选择GPU"},model:{value:(setupGPU.type),callback:function ($$v) {_vm.$set(setupGPU, "type", $$v)},expression:"setupGPU.type"}},_vm._l((_vm.formSelections.setupGPU),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.gpuPlus(_vm.form.computeNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.gpuMinus(_vm.form.computeNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupGPU.number),callback:function ($$v) {_vm.$set(setupGPU, "number", $$v)},expression:"setupGPU.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"step-cont",class:_vm.curStep == 4 ? 'active' : '',on:{"click":function($event){_vm.curStep = 4}}},[_c('el-row',{staticStyle:{"margin":"0","line-height":"40px"},attrs:{"gutter":20}},[_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":5}},[_c('el-radio',{attrs:{"label":"U3100"},model:{value:(_vm.form.storageNode.setupType),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupType", $$v)},expression:"form.storageNode.setupType"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":5}},[_c('el-radio',{attrs:{"label":"U3200"},model:{value:(_vm.form.storageNode.setupType),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupType", $$v)},expression:"form.storageNode.setupType"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":5}},[_c('el-radio',{attrs:{"label":"U5000"},model:{value:(_vm.form.storageNode.setupType),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupType", $$v)},expression:"form.storageNode.setupType"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.storageNode.numberStorage),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "numberStorage", $$v)},expression:"form.storageNode.numberStorage"}})],1)],1)],1),_vm._v(" "),_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.form.storageNode.setupType == 'U3100' ? _vm.formSelections.setupFri : (_vm.form.storageNode.setupType == 'U3200' ? _vm.formSelections.setupSed : _vm.formSelections.setupThr)))]),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType == 'U3100'),expression:"form.storageNode.setupType == 'U3100'"}],attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"控制器缓存","prop":"setupCache","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择缓存"},model:{value:(_vm.form.storageNode.setupCache),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupCache", $$v)},expression:"form.storageNode.setupCache"}},_vm._l((_vm.formSelections.setupCache),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.form.storageNode.setupDisks),function(setupDisk,index){return _c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType == 'U3100'),expression:"form.storageNode.setupType == 'U3100'"}],key:index + 'disks',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '控制器硬盘' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择硬盘"},model:{value:(setupDisk.type),callback:function ($$v) {_vm.$set(setupDisk, "type", $$v)},expression:"setupDisk.type"}},_vm._l((_vm.formSelections.setupDisk),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.diskPlus(_vm.form.storageNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.diskMinus(_vm.form.storageNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupDisk.number),callback:function ($$v) {_vm.$set(setupDisk, "number", $$v)},expression:"setupDisk.number"}})],1)],1)],1)}),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType == 'U3200'  || _vm.form.storageNode.setupType == 'U5000' ),expression:"form.storageNode.setupType == 'U3200'  || form.storageNode.setupType == 'U5000' "}],attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"双控制器缓存","prop":"setupDual","label-width":"100px"}},[_c('el-select',{attrs:{"placeholder":"请选择缓存"},model:{value:(_vm.form.storageNode.setupDual),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupDual", $$v)},expression:"form.storageNode.setupDual"}},_vm._l((_vm.formSelections.setupDual),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"扩展柜类型","prop":"setupExpansion","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择缓存"},model:{value:(_vm.form.storageNode.setupExpansion),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "setupExpansion", $$v)},expression:"form.storageNode.setupExpansion"}},_vm._l((_vm.formSelections.setupExpansion),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.storageNode.numberExpansion),callback:function ($$v) {_vm.$set(_vm.form.storageNode, "numberExpansion", $$v)},expression:"form.storageNode.numberExpansion"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.form.storageNode.setupExcabinets),function(setupExcabinet,index){return _c('el-row',{key:index + 'excabinets',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":index == 0 ? '扩展柜硬盘' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择硬盘"},model:{value:(setupExcabinet.type),callback:function ($$v) {_vm.$set(setupExcabinet, "type", $$v)},expression:"setupExcabinet.type"}},_vm._l((_vm.formSelections.setupExcabinet),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type,"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.excabinetPlus(_vm.form.storageNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.excabinetMinus(_vm.form.storageNode, index)}}}):_vm._e()],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupExcabinet.number),callback:function ($$v) {_vm.$set(setupExcabinet, "number", $$v)},expression:"setupExcabinet.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"step-cont",class:_vm.curStep == 5 ? 'active' : '',on:{"click":function($event){_vm.curStep = 5}}},[_c('el-tabs',{attrs:{"type":"card","stretch":true}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('el-checkbox',{attrs:{"true-label":"万兆网络"},model:{value:(_vm.form.networkNode.setupSwitchsSelect),callback:function ($$v) {_vm.$set(_vm.form.networkNode, "setupSwitchsSelect", $$v)},expression:"form.networkNode.setupSwitchsSelect"}}),_vm._v(" 万兆网络")],1),_vm._v(" "),_vm._l((_vm.form.networkNode.setupSwitchs),function(setupSwitch,index){return _c('el-row',{key:index + 'switchs',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":index == 0 ? '交换机型号' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择型号"},model:{value:(setupSwitch.type),callback:function ($$v) {_vm.$set(setupSwitch, "type", $$v)},expression:"setupSwitch.type"}},_vm._l((_vm.formSelections.setupSwitch),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.switchPlus(_vm.form.networkNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.switchMinus(_vm.form.networkNode, index)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(setupSwitch.type.split("|")[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupSwitch.number),callback:function ($$v) {_vm.$set(setupSwitch, "number", $$v)},expression:"setupSwitch.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('el-checkbox',{attrs:{"true-label":"Mellanox Infiniband网络"},model:{value:(_vm.form.networkNode.setupSwitchsMellanoxsSelect),callback:function ($$v) {_vm.$set(_vm.form.networkNode, "setupSwitchsMellanoxsSelect", $$v)},expression:"form.networkNode.setupSwitchsMellanoxsSelect"}}),_vm._v(" Mellanox Infiniband网络")],1),_vm._v(" "),_vm._l((_vm.form.networkNode.setupSwitchsMellanoxs),function(setupMellanox,index){return _c('el-row',{key:index + 'mellanox',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":index == 0 ? '交换机型号' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择型号"},model:{value:(setupMellanox.type),callback:function ($$v) {_vm.$set(setupMellanox, "type", $$v)},expression:"setupMellanox.type"}},_vm._l((_vm.formSelections.setupMellanox),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.mellanoxPlus(_vm.form.networkNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.mellanoxMinus(_vm.form.networkNode, index)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(setupMellanox.type.split('|')[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupMellanox.number),callback:function ($$v) {_vm.$set(setupMellanox, "number", $$v)},expression:"setupMellanox.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('el-checkbox',{attrs:{"true-label":"intel OPA网络"},model:{value:(_vm.form.networkNode.setupSwitchsIntelsSelect),callback:function ($$v) {_vm.$set(_vm.form.networkNode, "setupSwitchsIntelsSelect", $$v)},expression:"form.networkNode.setupSwitchsIntelsSelect"}}),_vm._v(" intel OPA网络")],1),_vm._v(" "),_vm._l((_vm.form.networkNode.setupSwitchsIntels),function(setupIntel,index){return _c('el-row',{key:index + 'intel',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":index == 0 ? '交换机型号' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择型号"},model:{value:(setupIntel.type),callback:function ($$v) {_vm.$set(setupIntel, "type", $$v)},expression:"setupIntel.type"}},_vm._l((_vm.formSelections.setupIntel),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.intelPlus(_vm.form.networkNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.intelMinus(_vm.form.networkNode, index)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(setupIntel.type.split('|')[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupIntel.number),callback:function ($$v) {_vm.$set(setupIntel, "number", $$v)},expression:"setupIntel.number"}})],1)],1)],1)})],2),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('el-checkbox',{attrs:{"true-label":"千兆网络"},model:{value:(_vm.form.networkNode.setupSwitchsThousandSelect),callback:function ($$v) {_vm.$set(_vm.form.networkNode, "setupSwitchsThousandSelect", $$v)},expression:"form.networkNode.setupSwitchsThousandSelect"}}),_vm._v(" 千兆网络")],1),_vm._v(" "),_vm._l((_vm.form.networkNode.setupSwitchsThousand),function(setupSwitch,index){return _c('el-row',{key:index + 'switchs',attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":index == 0 ? '交换机型号' : '',"prop":"type","label-width":"85px"}},[_c('el-select',{attrs:{"placeholder":"请选择型号"},model:{value:(setupSwitch.type),callback:function ($$v) {_vm.$set(setupSwitch, "type", $$v)},expression:"setupSwitch.type"}},_vm._l((_vm.formSelections.setupSwitchThousand),function(type,index){return _c('el-option',{key:index + type,attrs:{"label":type.split('|')[0],"value":type}})}),1),_vm._v(" "),_c('i',{staticClass:"el-icon-plus",on:{"click":function($event){return _vm.switchThousandPlus(_vm.form.networkNode)}}}),_vm._v(" "),(index != 0)?_c('i',{staticClass:"el-icon-minus",on:{"click":function($event){return _vm.switchThousandMinus(_vm.form.networkNode, index)}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(setupSwitch.type.split("|")[1]))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"单台数量"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(setupSwitch.number),callback:function ($$v) {_vm.$set(setupSwitch, "number", $$v)},expression:"setupSwitch.number"}})],1)],1)],1)})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"step-cont",class:_vm.curStep == 6 ? 'active' : '',on:{"click":function($event){_vm.curStep = 6}}},[_c('el-row',{attrs:{"gutter":30}},[(_vm.form.managementNode.numberMachine > 0)?_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v("管理节点"),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.form.managementNode.numberMachine)+"台")])]),_vm._v(" "),[_c('h5',[_vm._v("配置机型: "),_c('span',[_vm._v(_vm._s(_vm.form.managementNode.setupMachine))])]),_vm._v(" "),(_vm.form.managementNode.numberCPU > 0)?_c('h5',[_vm._v("处理器: "),_c('span',[_vm._v(_vm._s(_vm.form.managementNode.numberCPU)+" * "+_vm._s(_vm.form.managementNode.setupCPU.split('|')[0])+" "),_c('br'),_vm._v(_vm._s(_vm.form.managementNode.setupCPU.split('|')[1]))])]):_vm._e(),_vm._v(" "),(_vm.form.managementNode.numberMemery > 0)?_c('h5',[_vm._v("内存: "),_c('span',[_vm._v(_vm._s(_vm.form.managementNode.numberMemery)+" * "+_vm._s(_vm.form.managementNode.setupMemery))])]):_vm._e(),_vm._v(" "),(_vm.form.managementNode.setupNetworks.length > 0)?_c('h5',[_vm._v("网络: "),_vm._l((_vm.form.managementNode.setupNetworks),function(network,index){return (network.number > 0)?_c('span',{key:index + network.type},[_vm._v(_vm._s(network.number)+" * "+_vm._s(network.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.managementNode.setupHardDisks.length > 0)?_c('h5',[_vm._v("硬盘: "),_vm._l((_vm.form.managementNode.setupHardDisks),function(harddisk,index){return (harddisk.number > 0)?_c('span',{key:index + harddisk.type},[_vm._v(_vm._s(harddisk.number)+" * "+_vm._s(harddisk.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.managementNode.setupGPUs.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("GPU: "),_vm._l((_vm.form.managementNode.setupGPUs),function(gpu,index){return (gpu.number > 0)?_c('span',{key:index + gpu.type},[_vm._v(_vm._s(gpu.number)+" * "+_vm._s(gpu.type))]):_vm._e()})],2):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.form.loginNode.numberMachine > 0)?_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v("登录节点"),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.form.loginNode.numberMachine)+"台")])]),_vm._v(" "),[_c('h5',[_vm._v("配置机型: "),_c('span',[_vm._v(_vm._s(_vm.form.loginNode.setupMachine))])]),_vm._v(" "),(_vm.form.loginNode.numberCPU > 0)?_c('h5',[_vm._v("处理器: "),_c('span',[_vm._v(_vm._s(_vm.form.loginNode.numberCPU)+" * "+_vm._s(_vm.form.loginNode.setupCPU.split('|')[0])+" "),_c('br'),_vm._v(_vm._s(_vm.form.loginNode.setupCPU.split('|')[1]))])]):_vm._e(),_vm._v(" "),(_vm.form.loginNode.numberMemery > 0)?_c('h5',[_vm._v("内存: "),_c('span',[_vm._v(_vm._s(_vm.form.loginNode.numberMemery)+" * "+_vm._s(_vm.form.loginNode.setupMemery))])]):_vm._e(),_vm._v(" "),(_vm.form.loginNode.setupNetworks.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("网络: "),_vm._l((_vm.form.loginNode.setupNetworks),function(network,index){return (network.number > 0)?_c('span',{key:index + network.type},[_vm._v(_vm._s(network.number)+" * "+_vm._s(network.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.loginNode.setupHardDisks.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("硬盘: "),_vm._l((_vm.form.loginNode.setupHardDisks),function(harddisk,index){return (harddisk.number > 0)?_c('span',{key:index + harddisk.type},[_vm._v(_vm._s(harddisk.number)+" * "+_vm._s(harddisk.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.loginNode.setupGPUs.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("GPU: "),_vm._l((_vm.form.loginNode.setupGPUs),function(gpu,index){return (gpu.number > 0)?_c('span',{key:index + gpu.type},[_vm._v(_vm._s(gpu.number)+" * "+_vm._s(gpu.type))]):_vm._e()})],2):_vm._e()]],2):_vm._e(),_vm._v(" "),(_vm.form.computeNode.numberMachine > 0)?_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v("计算节点"),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.form.computeNode.numberMachine)+"台")])]),_vm._v(" "),[_c('h5',[_vm._v("配置机型: "),_c('span',[_vm._v(_vm._s(_vm.form.computeNode.setupMachine))])]),_vm._v(" "),(_vm.form.computeNode.numberCPU > 0)?_c('h5',[_vm._v("处理器: "),_c('span',[_vm._v(_vm._s(_vm.form.computeNode.numberCPU)+" * "+_vm._s(_vm.form.computeNode.setupCPU.split('|')[0])+" "),_c('br'),_vm._v(_vm._s(_vm.form.computeNode.setupCPU.split('|')[1]))])]):_vm._e(),_vm._v(" "),(_vm.form.computeNode.numberMemery > 0)?_c('h5',[_vm._v("内存: "),_c('span',[_vm._v(_vm._s(_vm.form.computeNode.numberMemery)+" * "+_vm._s(_vm.form.computeNode.setupMemery))])]):_vm._e(),_vm._v(" "),(_vm.form.computeNode.setupNetworks.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("网络: "),_vm._l((_vm.form.computeNode.setupNetworks),function(network,index){return (network.number > 0)?_c('span',{key:index + network.type},[_vm._v(_vm._s(network.number)+" * "+_vm._s(network.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.computeNode.setupHardDisks.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("硬盘: "),_vm._l((_vm.form.computeNode.setupHardDisks),function(harddisk,index){return (harddisk.number > 0)?_c('span',{key:index + harddisk.type},[_vm._v(_vm._s(harddisk.number)+" * "+_vm._s(harddisk.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.computeNode.setupGPUs.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("GPU: "),_vm._l((_vm.form.computeNode.setupGPUs),function(gpu,index){return (gpu.number > 0)?_c('span',{key:index + gpu.type},[_vm._v(_vm._s(gpu.number)+" * "+_vm._s(gpu.type))]):_vm._e()})],2):_vm._e()]],2):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v("存储节点"),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.form.storageNode.numberStorage)+"台")])]),_vm._v(" "),[_c('h5',[_vm._v("型号: "),_c('span',[_vm._v(_vm._s(_vm.form.storageNode.setupType))])]),_vm._v(" "),_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType == 'U3100'),expression:"form.storageNode.setupType == 'U3100'"}]},[_vm._v("缓存: "),_c('span',[_vm._v(_vm._s(_vm.form.storageNode.setupCache.split('|')[0]))])]),_vm._v(" "),(_vm.form.storageNode.setupDisks.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType == 'U3100'),expression:"form.storageNode.setupType == 'U3100'"}]},[_vm._v("硬盘:"),_vm._l((_vm.form.storageNode.setupDisks),function(disks,index){return (disks.number > 0)?_c('span',{key:index + disks.type},[_vm._v(_vm._s(disks.number)+" * "+_vm._s(disks.type))]):_vm._e()})],2):_vm._e(),_vm._v(" "),_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.storageNode.setupType != 'U3100'),expression:"form.storageNode.setupType != 'U3100'"}]},[_vm._v("双控制器缓存:"),_c('span',{staticStyle:{"width":"70%"}},[_vm._v(_vm._s(_vm.form.storageNode.setupDual))])]),_vm._v(" "),(_vm.form.storageNode.numberExpansion > 0)?_c('h5',[_vm._v("扩展柜: "),_c('span',[_vm._v(_vm._s(_vm.form.storageNode.numberExpansion)+" * "+_vm._s(_vm.form.storageNode.setupExpansion))])]):_vm._e(),_vm._v(" "),(_vm.form.storageNode.setupExcabinets.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("扩展柜硬盘:"),_vm._l((_vm.form.storageNode.setupExcabinets),function(excabinets,index){return (excabinets.number > 0)?_c('span',{key:index + excabinets.type,staticStyle:{"width":"70%"}},[_vm._v(_vm._s(excabinets.number)+" * "+_vm._s(excabinets.type))]):_vm._e()})],2):_vm._e()]],2),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[[(_vm.form.networkNode.setupSwitchsSelect)?_c('h4',[_vm._v("网络:"),_c('span',[_vm._v("万兆网络")])]):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsSelect && _vm.form.networkNode.setupSwitchs.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("交换机型号:"),_vm._l((_vm.form.networkNode.setupSwitchs),function(switchs,index){return (switchs.number > 0)?_c('span',{key:index + switchs.type,staticStyle:{"width":"70%"}},[_vm._v(_vm._s(switchs.number)+" * "+_vm._s(switchs.type.split('|')[0])),_c('br'),_vm._v(_vm._s(switchs.type.split('|')[1]))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsMellanoxsSelect)?_c('h4',[_vm._v("网络:"),_c('span',[_vm._v("Mellanox Infiniband网络")])]):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsMellanoxsSelect && _vm.form.networkNode.setupSwitchsMellanoxs.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("交换机型号:"),_vm._l((_vm.form.networkNode.setupSwitchsMellanoxs),function(mellanox,index){return (mellanox.number > 0)?_c('span',{key:index + mellanox.type,staticStyle:{"width":"70%"}},[_vm._v(_vm._s(mellanox.number)+" * "+_vm._s(mellanox.type.split('|')[0])),_c('br'),_vm._v(_vm._s(mellanox.type.split('|')[1]))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsIntelsSelect)?_c('h4',[_vm._v("网络:"),_c('span',[_vm._v("intel OPA网络")])]):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsIntelsSelect && _vm.form.networkNode.setupSwitchsIntels.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("交换机型号:"),_vm._l((_vm.form.networkNode.setupSwitchsIntels),function(intel,index){return (intel.number > 0)?_c('span',{key:index + intel.type,staticStyle:{"width":"70%"}},[_vm._v(_vm._s(intel.number)+" * "+_vm._s(intel.type.split('|')[0])),_c('br'),_vm._v(_vm._s(intel.type.split('|')[1]))]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsThousandSelect)?_c('h4',[_vm._v("网络:"),_c('span',[_vm._v("千兆网络")])]):_vm._e(),_vm._v(" "),(_vm.form.networkNode.setupSwitchsThousandSelect && _vm.form.networkNode.setupSwitchsThousand.map(function (s) { return s.number; }).reduce(function (t, s) { return t + s; }) > 0)?_c('h5',[_vm._v("交换机型号:"),_vm._l((_vm.form.networkNode.setupSwitchsThousand),function(switchs,index){return (switchs.number > 0)?_c('span',{key:index + switchs.type,staticStyle:{"width":"70%"}},[_vm._v(_vm._s(switchs.number)+" * "+_vm._s(switchs.type.split('|')[0])),_c('br'),_vm._v(_vm._s(switchs.type.split('|')[1]))]):_vm._e()})],2):_vm._e()]],2)],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"config-step-footer"},[(_vm.curStep < 6)?_c('el-button',{on:{"click":function($event){_vm.curStep = 6}}},[_vm._v("确定")]):_vm._e(),_vm._v(" "),(_vm.curStep < 5)?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.curStep = _vm.curStep + 1 > 6 ? 6 : _vm.curStep + 1}}},[_vm._v("下一步")]):_vm._e(),_vm._v(" "),(_vm.curStep == 5)?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.curStep = 6}}},[_vm._v("完成")]):_vm._e(),_vm._v(" "),(_vm.curStep == 6)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadWord}},[_vm._v("下载word")]):_vm._e()],1)])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-cont"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(14)}})]),_vm._v(" "),_c('div',{staticClass:"contact"},[_c('h4',[_vm._v("联系我们")]),_vm._v(" "),_c('p',[_vm._v("地址：南京市江北新区腾飞大厦A座4楼")]),_vm._v(" "),_c('p',[_vm._v("电话：025-68155007")])]),_vm._v(" "),_c('div',{staticClass:"qr"},[_c('img',{staticClass:"tu",attrs:{"src":__webpack_require__(22)}}),_c('br'),_vm._v(" "),_c('span',{staticClass:"spa"},[_vm._v("关注我们")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer footer2"},[_c('p',[_vm._v("版权所有 © 南京信易达计算技术有限公司 "),_c('a',{staticStyle:{"color":"rgba(255,255,255, .4)"},attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index","target":"_blank"}},[_vm._v("苏ICP备2021021510号-1")]),_vm._v(" 苏公网安备 0000000000号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[140]);


// WEBPACK FOOTER //
// static/js/app.33dbd798d0cbd62be13e.js